import React from "react";
import logo_studio_m from '../assets/img/studio-m-2022.png';

class Logo extends React.Component {
  render() {
    if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "aftec"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 154.5 154.37"
          className="icon icon-pigier-white"
        >
          <g id="Calque_5" data-name="Calque 5">
            <path
              className="cls-1"
              d="M154.5,105.42a49,49,0,0,1-48.95,49H0V49A49,49,0,0,1,49,0H154.5Z"
              fill="#0076b6"
            />
            <path className="cls-2" d="M117.1,56.3" fill="#ffffff" />
            <path
              className="cls-2"
              d="M38.24,95.5,36.6,90.16H27L25.2,95.5H19.46l9.25-25.92H35L44.13,95.5ZM31.79,75.4h0L28.44,85.71H35Z"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M50.57,84.57V95.5H45.15V69.58H63.61v4.53h-13V80H62v4.56Z"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M72.49,95.5V74.11H64.68V69.58H85.76v4.53H77.91V95.5Z"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M86.86,95.5V69.58h19v4.53H92.13v5.54h12.68v4.57H92.13V90.9h14.4v4.6Z"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M130.27,86.6c-1.09,5.9-5.15,9.8-11.16,9.8-6.8,0-12-4.64-12-13.54s4.65-14.14,12.06-14.14c6.48,0,10.58,4.14,11.09,9.37h-5.43a5.83,5.83,0,0,0-5.62-4.68c-4.49,0-6.59,3.47-6.59,9.13s2.1,9.14,6.32,9.14c3.2,0,5.15-1.84,5.89-5.08Z"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M117.3,56.32l-.45-2.1s10.77-2.64,17.59,3l-2.32,2s-2.35-1.55-7-.79c0,0,6.37.52,10.21,5.24l-1.85,1.2s-2-2.46-6.77-3.36a15.56,15.56,0,0,1,4.85,3.79l-.95,1.78a14.36,14.36,0,0,0-12.74-3.94l.19-1.76a11.46,11.46,0,0,1,6.46-.53,9.5,9.5,0,0,0-4.61-1.47l-.22-1.53a25.92,25.92,0,0,1,9.37-.68S124.75,55,117.3,56.32Z"
              fill="#ffffff"
            />
          </g>
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "ipac"
    ) {
      return (
        <svg
          id="Calque_8"
          data-name="Calque 8"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 154.81 154.68"
          className="icon icon-pigier-white"
        >
          <text
            className="cls-1"
            transform="translate(40.02 95.52)"
            style={{
              fontSize: "39.03px",
              fontFamily: "CoolveticaRg-Regular, Coolvetica"
            }}
            fill="#ffffff"
          >
            I
            <tspan
              className="cls-2"
              x="7.3"
              y="0"
              style={{ letterSpacing: "-0.11em" }}
            >
              P
            </tspan>
            <tspan
              className="cls-3"
              x="23.69"
              y="0"
              style={{ letterSpacing: "-0.07em" }}
            >
              A
            </tspan>
            <tspan
              className="cls-4"
              x="46.06"
              y="0"
              style={{ letterSpacing: "0em" }}
            >
              C
            </tspan>
          </text>
          <path
            className="cls-5"
            d="M112.31,53.87v4.24H108A5.46,5.46,0,0,1,112.31,53.87Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M118.7,58.11h-4.2V53.9A5.49,5.49,0,0,1,118.7,58.11Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M112.31,60.3v4.35a5.46,5.46,0,0,1-4.37-4.35Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M118.72,60.3a5.45,5.45,0,0,1-4.22,4.33V60.3Z"
            fill="#ffffff"
          />
          <path
            className="cls-6"
            d="M154.81,105.64a49,49,0,0,1-49,49H0V49.05A49,49,0,0,1,49.05,0H154.81Z"
            fill="#be2d24"
          />
          <text
            className="cls-1"
            transform="translate(40.03 95.42)"
            style={{
              fontSize: "39.03px",
              fontFamily: "CoolveticaRg-Regular, Coolvetica"
            }}
            fill="#ffffff"
          >
            I
            <tspan
              className="cls-2"
              x="7.3"
              y="0"
              style={{ letterSpacing: "-0.11em" }}
            >
              P
            </tspan>
            <tspan
              className="cls-3"
              x="23.69"
              y="0"
              style={{ letterSpacing: "-0.07em" }}
            >
              A
            </tspan>
            <tspan
              className="cls-4"
              x="46.06"
              y="0"
              style={{ letterSpacing: "0em" }}
            >
              C
            </tspan>
          </text>
          <path
            className="cls-5"
            d="M112.32,53.77v4.28H108A5.46,5.46,0,0,1,112.32,53.77Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M108,60.23h4.28v4.28A5.48,5.48,0,0,1,108,60.23Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M114.5,60.23h4.28a5.5,5.5,0,0,1-4.28,4.28Z"
            fill="#ffffff"
          />
          <path
            className="cls-5"
            d="M118.78,58.05H114.5V53.77A5.48,5.48,0,0,1,118.78,58.05Z"
            fill="#ffffff"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "ipacBachelorFactory"
    ) {
      return (
        <svg
          id="Calque_1"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 125.5 270.33"
          className="icon icon-pigier-white"
        >
          <defs>
            <clipPath id="clip-path" transform="translate(81.91 7.39)">
              <path
                d="M267.4,159.93a9.21,9.21,0,0,0-6.5-11l-6.32-1.76c-8.18-2.28-14.23-9.85-14.46-16.93s5.3-15,13.31-17.85l6.19-2.17a9.21,9.21,0,0,0,5.75-11.36l-2.81-9.26a9.21,9.21,0,0,0-11.1-6.24l-6.37,1.64c-8.23,2.12-17.26-1.41-21-7.42S221.17,62,226.71,55.51l4.28-5a9.2,9.2,0,0,0-.7-12.71l-7.07-6.62a9.21,9.21,0,0,0-12.73.15l-4.68,4.6c-6.07,5.94-15.65,7.39-21.89,4.06s-10.38-12.1-8.81-20.45l1.21-6.45a9.19,9.19,0,0,0-6.95-10.66L159.93.24a9.21,9.21,0,0,0-11,6.49l-1.76,6.33c-2.28,8.18-9.85,14.22-16.93,14.46s-15-5.3-17.84-13.31L110.27,8A9.2,9.2,0,0,0,98.92,2.26L89.65,5.08a9.2,9.2,0,0,0-6.24,11.1l1.64,6.36c2.12,8.23-1.41,17.27-7.42,21S62,46.46,55.51,40.93l-5-4.29a9.21,9.21,0,0,0-12.71.7L31.2,44.41a9.2,9.2,0,0,0,.14,12.73l4.6,4.69c5.94,6.06,7.39,15.64,4.06,21.89s-12.1,10.37-20.45,8.8L13.1,91.31a9.19,9.19,0,0,0-10.66,7L.24,107.7a9.2,9.2,0,0,0,6.49,11l6.33,1.76c8.18,2.28,14.22,9.86,14.46,16.93s-5.3,15-13.31,17.85L8,157.37a9.2,9.2,0,0,0-5.76,11.35L5.08,178a9.2,9.2,0,0,0,11.1,6.23l6.36-1.63c8.23-2.12,17.27,1.41,21,7.41s2.91,15.67-2.62,22.12l-4.29,5a9.21,9.21,0,0,0,.7,12.71l7.07,6.62a9.2,9.2,0,0,0,12.73-.15l4.69-4.59c6.06-5.95,15.64-7.39,21.89-4.06s10.37,12.1,8.8,20.45l-1.21,6.45a9.21,9.21,0,0,0,7,10.66l9.43,2.19a9.19,9.19,0,0,0,11-6.49l1.76-6.32c2.28-8.19,9.86-14.23,16.93-14.46s15,5.3,17.85,13.31l2.18,6.19a9.2,9.2,0,0,0,11.35,5.75l9.27-2.81a9.21,9.21,0,0,0,6.24-11.1l-1.64-6.37c-2.12-8.23,1.41-17.26,7.41-21s15.67-2.92,22.12,2.62l5,4.28a9.2,9.2,0,0,0,12.71-.7l6.62-7.07a9.2,9.2,0,0,0-.15-12.73l-4.59-4.68c-5.95-6.06-7.39-15.65-4.06-21.89s12.1-10.38,20.45-8.81l6.45,1.21a9.2,9.2,0,0,0,10.66-6.95Z"
                fill="none"
              />
            </clipPath>
          </defs>
          <title>IpacBachelorFactory</title>
          <g clip-path="url(#clip-path)">
            <circle
              cx="215.73"
              cy="169.23"
              r="168.55"
              fill="#e52330"
              opacity="0.65"
            />
            <circle cx="344.76" cy="239.59" r="230.74" fill="#e52330" />
            <circle cx="108.61" cy="108.61" r="108.61" fill="#cd1b2d" />
          </g>
          <path
            d="M69.43,133.41a6.17,6.17,0,0,1-2.6,5.31q-2.6,1.89-7.5,1.89H43.81v-4h4.52V118.72H43.81v-4H58.66a9.93,9.93,0,0,1,6.5,1.89,6.14,6.14,0,0,1,2.27,5,5.76,5.76,0,0,1-.92,3.28,6.93,6.93,0,0,1-2.5,2.26C67.62,128.11,69.43,130.2,69.43,133.41Zm-16.2-14.69v7.16h4.22q5,0,5-3.66a3,3,0,0,0-1.19-2.67,5,5,0,0,0-2.92-.83ZM64.42,133a3,3,0,0,0-1.34-2.7,7.62,7.62,0,0,0-3.93-.88H53.23v7.19H59Q64.42,136.65,64.42,133Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M93.47,140.12a4.74,4.74,0,0,1-1.4.56,7.54,7.54,0,0,1-1.92.23,4,4,0,0,1-2.5-.81,4.17,4.17,0,0,1-1.49-2.28q-3.73,3.31-7.38,3.32a6.72,6.72,0,0,1-4.38-1.45,5.66,5.66,0,0,1-.71-7.41,6.48,6.48,0,0,1,2.77-2.05,9.43,9.43,0,0,1,3.63-.7,13.39,13.39,0,0,1,3,.32,18.92,18.92,0,0,1,2.79.92v-1.39a2.48,2.48,0,0,0-1.23-2.26,5.91,5.91,0,0,0-3.14-.75,19.79,19.79,0,0,0-6.86,1.54l-.94-3.58a21.84,21.84,0,0,1,8.44-1.92,8.88,8.88,0,0,1,6.08,1.9,6.69,6.69,0,0,1,2.13,5.26v6c0,1,.36,1.47,1.09,1.47a2.69,2.69,0,0,0,1.06-.22ZM78.1,136.75a3.53,3.53,0,0,0,2,.51,7.57,7.57,0,0,0,2.63-.61,13.71,13.71,0,0,0,3.21-1.84v-1a13.77,13.77,0,0,0-4.9-.87,5.92,5.92,0,0,0-2.62.62,1.86,1.86,0,0,0-1.07,1.72A1.66,1.66,0,0,0,78.1,136.75Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M112.91,137.82a12.42,12.42,0,0,1-3.81,2.45,11.7,11.7,0,0,1-4.52.87,10,10,0,0,1-4.82-1.21,9.26,9.26,0,0,1-3.54-3.35,9.08,9.08,0,0,1-1.32-4.86A9.4,9.4,0,0,1,96.12,127a9.28,9.28,0,0,1,3.28-3.39,8.41,8.41,0,0,1,4.43-1.25,7.37,7.37,0,0,1,3.09.59,7.08,7.08,0,0,1,2.3,1.71v-1.81h3.31v6.33l-2,.15a5.92,5.92,0,0,0-5.28-3.12,5.34,5.34,0,0,0-3.92,1.52,5.25,5.25,0,0,0-1.54,3.9,5.54,5.54,0,0,0,.73,2.87,5.44,5.44,0,0,0,2,1.94,5.58,5.58,0,0,0,2.66.73,7.16,7.16,0,0,0,3-.62,12,12,0,0,0,2.73-1.83Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M140.45,136.88v3.73h-11v-3.73h3.05v-6.14a4.52,4.52,0,0,0-1-3,3.41,3.41,0,0,0-2.73-1.11q-2.75,0-6,3.81v6.48h3.06v3.73H114.27v-3.73H118V118.49h-3.76v-3.73h8.47v12a15.5,15.5,0,0,1,3.87-3.31,8.13,8.13,0,0,1,4.12-1.06,5.72,5.72,0,0,1,4.82,2.09c1.08,1.4,1.62,3.46,1.62,6.2v6.18Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M160.72,137.9a12.94,12.94,0,0,1-8.7,3.24,11.91,11.91,0,0,1-5-1.06,9,9,0,0,1-3.74-3.09,8.19,8.19,0,0,1-1.44-4.86,9.18,9.18,0,0,1,1.44-5.14,9.62,9.62,0,0,1,3.8-3.41,11.06,11.06,0,0,1,5-1.21,11.27,11.27,0,0,1,4.16.72,6.75,6.75,0,0,1,2.87,2,4.69,4.69,0,0,1,1,3,4.38,4.38,0,0,1-1,2.92,6.19,6.19,0,0,1-2.72,1.83,10.53,10.53,0,0,1-3.59.6,14,14,0,0,1-3.34-.38,21.43,21.43,0,0,1-3.14-1,4.76,4.76,0,0,0,1.69,3.79,6.25,6.25,0,0,0,4.11,1.37,10.15,10.15,0,0,0,6.55-2.37ZM149.29,127a6.06,6.06,0,0,0-2.32,2.47,14.28,14.28,0,0,0,4.79.83,6,6,0,0,0,2.73-.61,1.72,1.72,0,0,0,1-1.58,1.7,1.7,0,0,0-.83-1.47,3.77,3.77,0,0,0-2.18-.56A6.06,6.06,0,0,0,149.29,127Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M174.47,136.88v3.73H162.19v-3.73H166V118.49h-3.77v-3.73h8.48v22.12Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M181.07,140a9.38,9.38,0,0,1-3.69-3.32,9.26,9.26,0,0,1,0-9.79,9.31,9.31,0,0,1,3.69-3.32,10.87,10.87,0,0,1,9.81,0,9.42,9.42,0,0,1,3.73,3.32,8.71,8.71,0,0,1,1.42,4.89,8.85,8.85,0,0,1-1.38,4.9A9.33,9.33,0,0,1,191,140a10.84,10.84,0,0,1-5,1.17A10.69,10.69,0,0,1,181.07,140Zm8.61-4.11a6.54,6.54,0,0,0,0-8.21,5.08,5.08,0,0,0-7.31,0,6.54,6.54,0,0,0,0,8.21,5.08,5.08,0,0,0,7.31,0Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M216.67,122.41v7.91h-4.1v-3.24a5.15,5.15,0,0,0-2.62,1,15.16,15.16,0,0,0-3.11,2.7v6.14h3.8v3.73H198.36v-3.73h3.77V126.59h-3.77v-3.73h8.48V127a17,17,0,0,1,4-3.36,7.92,7.92,0,0,1,4-1.24Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M100.68,149.74V159H96.27V153.7H84.85v7.53h4.71V158h3.73v10.06H89.56v-3.24H84.85v6.82h4.86v4H75.44v-4H80V153.7H75.44v-4Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M122,175.1a5,5,0,0,1-1.39.56,7.66,7.66,0,0,1-1.92.23,4.06,4.06,0,0,1-2.51-.81,4.22,4.22,0,0,1-1.49-2.28q-3.72,3.31-7.38,3.31a6.66,6.66,0,0,1-4.37-1.45,5.06,5.06,0,0,1-1.77-4.16,5.12,5.12,0,0,1,1-3.24,6.61,6.61,0,0,1,2.77-2,9.51,9.51,0,0,1,3.64-.7,13.3,13.3,0,0,1,3,.32,17.15,17.15,0,0,1,2.79.92v-1.39a2.48,2.48,0,0,0-1.22-2.26,6,6,0,0,0-3.15-.76,19.88,19.88,0,0,0-6.86,1.55l-.94-3.58a21.88,21.88,0,0,1,8.44-1.92,8.84,8.84,0,0,1,6.09,1.9,6.72,6.72,0,0,1,2.12,5.26v5.95c0,1,.37,1.47,1.1,1.47a2.65,2.65,0,0,0,1-.23Zm-15.37-3.38a3.55,3.55,0,0,0,2,.51,7.53,7.53,0,0,0,2.64-.6,13.53,13.53,0,0,0,3.2-1.85v-1a13.69,13.69,0,0,0-4.9-.87,5.79,5.79,0,0,0-2.62.62,1.86,1.86,0,0,0-1.07,1.72A1.63,1.63,0,0,0,106.63,171.72Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M141.45,172.8a12.74,12.74,0,0,1-3.81,2.45,11.73,11.73,0,0,1-4.52.86,10,10,0,0,1-4.82-1.2,9.3,9.3,0,0,1-3.55-3.35,9.14,9.14,0,0,1-1.31-4.87,9.4,9.4,0,0,1,4.5-8.1,8.47,8.47,0,0,1,4.43-1.24,7.36,7.36,0,0,1,3.08.59,6.71,6.71,0,0,1,2.3,1.71v-1.81h3.32v6.33l-2,.15a5.93,5.93,0,0,0-5.27-3.13,5.33,5.33,0,0,0-3.92,1.53,5.26,5.26,0,0,0-1.55,3.9,5.51,5.51,0,0,0,.74,2.86,5.21,5.21,0,0,0,2,1.94,5.55,5.55,0,0,0,2.65.74,7.24,7.24,0,0,0,3-.62,12.29,12.29,0,0,0,2.73-1.83Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M159.46,174.23a13.3,13.3,0,0,1-2.79,1.36,10.21,10.21,0,0,1-3.24.49,6.42,6.42,0,0,1-5-2,7.9,7.9,0,0,1-1.83-5.54v-7h-3.73v-3.73h3.73v-4.93h4.71v4.93h5.42v3.73h-5.42v7a3.66,3.66,0,0,0,.75,2.5,2.71,2.71,0,0,0,2.15.85,5.14,5.14,0,0,0,1.77-.3,11.43,11.43,0,0,0,1.85-.9Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M164.65,175a9.45,9.45,0,0,1-3.69-3.32,9.33,9.33,0,0,1,0-9.8,9.43,9.43,0,0,1,3.69-3.31,10.89,10.89,0,0,1,9.82,0,9.54,9.54,0,0,1,3.73,3.31,8.76,8.76,0,0,1,1.41,4.9,8.93,8.93,0,0,1-1.37,4.9,9.35,9.35,0,0,1-3.68,3.32,11.16,11.16,0,0,1-9.91,0Zm8.61-4.11a6.54,6.54,0,0,0,0-8.21,4.77,4.77,0,0,0-3.63-1.55,4.85,4.85,0,0,0-3.68,1.55,6.54,6.54,0,0,0,0,8.21,4.84,4.84,0,0,0,3.68,1.54A4.76,4.76,0,0,0,173.26,170.84Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M199.75,157.39v7.91h-4.1v-3.24a5.19,5.19,0,0,0-2.62,1,15.16,15.16,0,0,0-3.11,2.7v6.14h3.8v3.73H181.44v-3.73h3.77V161.57h-3.77v-3.73h8.48V162a17.39,17.39,0,0,1,4-3.35,7.82,7.82,0,0,1,4-1.24Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M225.13,161.57h-2.38l-7.08,15.49a16.89,16.89,0,0,1-3.86,5.67,7.29,7.29,0,0,1-4.92,1.82,7.38,7.38,0,0,1-2.75-.47,17.07,17.07,0,0,1-2.68-1.37l1.85-3.58a13.51,13.51,0,0,0,1.75.92,4.67,4.67,0,0,0,1.83.36,4.41,4.41,0,0,0,2.84-1,8.56,8.56,0,0,0,2.25-3.24l0-.11-7.42-14.51H202v-3.73h10.29v3.35h-2.75l4.59,10.06,4.41-10.06H216v-3.35h9.16Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M83.13,82.67V104.9h5.39v1.8H75.67v-1.8H81V82.67H75.67V80.86H88.52v1.81Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M108.68,89.58a8,8,0,0,1,3,3.18,9.94,9.94,0,0,1,1.11,4.75,10.23,10.23,0,0,1-1.22,5,9,9,0,0,1-3.3,3.43,8.6,8.6,0,0,1-4.48,1.22,8.27,8.27,0,0,1-3.54-.73,12.1,12.1,0,0,1-3-2v8.74h4.59v1.77h-11v-1.77h4.33V90.73H90.82V89h6.37v3.13a11.87,11.87,0,0,1,3.37-2.62,8.38,8.38,0,0,1,4-1A8,8,0,0,1,108.68,89.58Zm-1.57,14.81a7.07,7.07,0,0,0,2.6-2.81,8.55,8.55,0,0,0,1-4.07,8.24,8.24,0,0,0-.84-3.82,6.11,6.11,0,0,0-5.6-3.41,7.65,7.65,0,0,0-3.79,1A11.9,11.9,0,0,0,97.19,94v8.7a9.45,9.45,0,0,0,6.32,2.72A6.83,6.83,0,0,0,107.11,104.39Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M136,106.33a4,4,0,0,1-2.3.64,2.84,2.84,0,0,1-2-.79,3.68,3.68,0,0,1-1-2.26q-4.26,3.27-7.69,3.27a7.13,7.13,0,0,1-4.54-1.47,4.84,4.84,0,0,1-1.86-4,4.77,4.77,0,0,1,1-3,6.33,6.33,0,0,1,2.67-2,9.84,9.84,0,0,1,3.81-.71,15.47,15.47,0,0,1,3.26.32,23.91,23.91,0,0,1,3.29,1V95.18a4.54,4.54,0,0,0-1.41-3.72,5.67,5.67,0,0,0-3.67-1.14,14.8,14.8,0,0,0-3.66.45,23.66,23.66,0,0,0-3.73,1.32l-.49-1.74a20.2,20.2,0,0,1,8-1.88,7.37,7.37,0,0,1,5,1.66q1.91,1.65,1.9,5.12v7.46c0,1.63.52,2.45,1.55,2.45a3.35,3.35,0,0,0,1.39-.41Zm-16-1.92a5.44,5.44,0,0,0,3.29,1q3.28,0,7.31-3.06v-3.5a19.58,19.58,0,0,0-6.48-1.17,6.83,6.83,0,0,0-3.86,1.06,3.32,3.32,0,0,0-1.6,2.94A3.23,3.23,0,0,0,120,104.41Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
          <path
            d="M155.66,103.77a13.5,13.5,0,0,1-3.52,2.5,10,10,0,0,1-4.43.92,9.37,9.37,0,0,1-4.41-1.11A8.88,8.88,0,0,1,138.55,98a9.92,9.92,0,0,1,1.19-4.84,9.19,9.19,0,0,1,3.2-3.43,8.21,8.21,0,0,1,4.43-1.26A7.29,7.29,0,0,1,154,91.82V89h1.66v6l-.9.11a7.72,7.72,0,0,0-2.64-3.6,7.19,7.19,0,0,0-4.22-1.18,6.93,6.93,0,0,0-3.67,1A6.79,6.79,0,0,0,141.61,94a8.23,8.23,0,0,0-1,4,7.29,7.29,0,0,0,1,3.88,7.13,7.13,0,0,0,2.69,2.6,7.47,7.47,0,0,0,3.47,1,7.84,7.84,0,0,0,3.69-.76,11.61,11.61,0,0,0,3-2.22Z"
            transform="translate(81.91 7.39)"
            fill="#fff"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "ipacDesign"
    ) {
      return (
        <svg
          id="Calque_1"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 118.68 109.12"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <text
            transform="translate(0 34.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            I
          </text>
          <text
            transform="translate(12.12 34.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            P
          </text>
          <text
            transform="translate(30.8 34.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            <tspan letter-spacing="0em">A</tspan>
            <tspan x="22.44" y="0">
              C
            </tspan>
          </text>
          <text
            transform="translate(0 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            D
          </text>
          <text
            transform="translate(22.36 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            E
          </text>
          <text
            transform="translate(41.8 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            S
          </text>
          <text
            transform="translate(62.76 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            I
          </text>
          <text
            transform="translate(73.28 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            G
          </text>
          <text
            transform="translate(95.72 67.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            N
          </text>
          <text
            transform="translate(0 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            G
          </text>
          <text
            transform="translate(21.04 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            E
          </text>
          <text
            transform="translate(39.08 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            N
          </text>
          <text
            transform="translate(60.84 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            E
          </text>
          <text
            transform="translate(78.88 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            V
          </text>
          <text
            transform="translate(98.44 100.28)"
            font-size="40"
            fill="#1d1d1b"
            font-family="HelveticaNeue-CondensedBold, Helvetica Neue"
            font-weight="700"
          >
            E
          </text>
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "ipacELearning"
    ) {
      return (
        <svg
          id="Calque_1"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 257.73 38.14"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <path className="cls-1" d="M181.51,28.88,184.94,9H192l-3.43,19.92Z" />
          <path
            className="cls-1"
            d="M205.06,21.65h-2.42l-1.24,7.23h-7.06L197.77,9h10.38c6.43,0,8.26,2.32,7.56,6.36C215,19.59,211,21.65,205.06,21.65ZM206,12h-1.69l-1.2,6.94c3.32,0,4.95-1.41,5.35-3.73C208.79,13.32,207.84,12,206,12Z"
          />
          <path
            className="cls-1"
            d="M227.38,28.88l-.74-3.61h-7.57l-1.95,3.61h-4.86l0-.25L223.87,9h7.18l4.07,19.67-.05.25Zm-2.59-14.42-3.95,7.38H226Z"
          />
          <path
            className="cls-1"
            d="M252.35,8.31c-6.91,0-13.19,4.2-14.29,10.6s3.72,10.62,10.63,10.62a15.73,15.73,0,0,0,9-2.9L255.4,24a10,10,0,0,1-5.63,2c-3.2,0-4.88-2.16-4-7.16s3.3-7.23,6.5-7.23a7.12,7.12,0,0,1,4.92,2.1l.56-.46V9.45A12.77,12.77,0,0,0,252.35,8.31Z"
          />
          <path
            className="cls-2"
            d="M55.36,32.76h-1l-.42-1.24H51.5l-.42,1.24h-1l2.26-6.17h.76Zm-1.69-2L52.74,28l-1,2.73Z"
          />
          <path
            className="cls-2"
            d="M62.27,28.46a1.9,1.9,0,0,1-.24,1,1.65,1.65,0,0,1-.69.67,2.19,2.19,0,0,1-1,.24H58.9v2.43H58V26.59H60.3a2.38,2.38,0,0,1,.81.14,1.84,1.84,0,0,1,.63.4,1.55,1.55,0,0,1,.4.58A2,2,0,0,1,62.27,28.46Zm-.93,0a1,1,0,0,0-.3-.75,1.09,1.09,0,0,0-.79-.28H58.9v2.05h1.35a1.11,1.11,0,0,0,.79-.27A1,1,0,0,0,61.34,28.46Z"
          />
          <path
            className="cls-2"
            d="M69.45,28.46a1.9,1.9,0,0,1-.24,1,1.65,1.65,0,0,1-.69.67,2.19,2.19,0,0,1-1,.24h-1.4v2.43h-1V26.59h2.35a2.38,2.38,0,0,1,.81.14,1.84,1.84,0,0,1,.63.4,1.55,1.55,0,0,1,.4.58A2,2,0,0,1,69.45,28.46Zm-.93,0a1,1,0,0,0-.3-.75,1.09,1.09,0,0,0-.79-.28H66.08v2.05h1.35a1.13,1.13,0,0,0,.79-.27A1,1,0,0,0,68.52,28.46Z"
          />
          <path
            className="cls-2"
            d="M76.81,32.76H75.72l-1.3-2.59H73.26v2.59h-1V26.59h2.4a2.21,2.21,0,0,1,1,.23,1.72,1.72,0,0,1,.67.64,1.91,1.91,0,0,1,.23.93A1.61,1.61,0,0,1,75.4,30ZM75.69,28.4a.93.93,0,0,0-.29-.71,1.09,1.09,0,0,0-.76-.26H73.26v1.93h1.38a1,1,0,0,0,.76-.26A.89.89,0,0,0,75.69,28.4Z"
          />
          <path
            className="cls-2"
            d="M83.66,32.76H79.72V26.59h3.94v.84h-3v1.8h2.56v.83H80.66v1.86h3Z"
          />
          <path
            className="cls-2"
            d="M91.32,32.76h-.86l-2.84-4.34v4.34h-1V26.59h.87l2.85,4.33V26.59h.93Z"
          />
          <path
            className="cls-2"
            d="M99.05,29.63v.31a7.49,7.49,0,0,1,0,.87,2.67,2.67,0,0,1-.17.73,1.92,1.92,0,0,1-.42.64,2.17,2.17,0,0,1-1.59.58H94.66V26.59h2.17a2.13,2.13,0,0,1,1.59.58,1.84,1.84,0,0,1,.42.62,2.47,2.47,0,0,1,.17.7,6.67,6.67,0,0,1,0,.83Zm-.94,0c0-.35,0-.62,0-.82a2.34,2.34,0,0,0-.09-.54,1.19,1.19,0,0,0-.22-.42,1.36,1.36,0,0,0-1.05-.42H95.6v4.49h1.14a1.36,1.36,0,0,0,1.05-.42,1.25,1.25,0,0,0,.27-.65A9.58,9.58,0,0,0,98.11,29.63Z"
          />
          <path
            className="cls-2"
            d="M106.66,32.76h-1.09l-1.3-2.59H103.1v2.59h-.94V26.59h2.4a2.17,2.17,0,0,1,1,.23,1.66,1.66,0,0,1,.67.64,1.81,1.81,0,0,1,.24.93,1.65,1.65,0,0,1-.34,1.07,1.68,1.68,0,0,1-.89.57Zm-1.12-4.36a.93.93,0,0,0-.29-.71,1.09,1.09,0,0,0-.76-.26H103.1v1.93h1.39a1.06,1.06,0,0,0,.76-.26A.89.89,0,0,0,105.54,28.4Z"
          />
          <path
            className="cls-2"
            d="M113.51,32.76h-4V26.59h4v.84h-3v1.8h2.56v.83h-2.56v1.86h3Z"
          />
          <path
            className="cls-2"
            d="M124.28,32.76h-4V26.59h4v.84h-3v1.8h2.56v.83h-2.56v1.86h3Z"
          />
          <path
            className="cls-2"
            d="M131.93,32.76h-.85l-2.85-4.34v4.34h-.94V26.59h.86L131,30.92V26.59h.93Z"
          />
          <path className="cls-2" d="M143,32.76h-3.91V26.59H140v5.33h3Z" />
          <path className="cls-2" d="M146.74,32.76h-1V26.59h1Z" />
          <path
            className="cls-2"
            d="M154.32,30.37a3.68,3.68,0,0,1-.12,1,2,2,0,0,1-.43.73,2.26,2.26,0,0,1-1.7.7,2.49,2.49,0,0,1-.61-.08,2.21,2.21,0,0,1-1-.58,1.67,1.67,0,0,1-.41-.63,2.37,2.37,0,0,1-.16-.72c0-.26,0-.64,0-1.13s0-.67,0-.89a5.07,5.07,0,0,1,.06-.6,2.13,2.13,0,0,1,.18-.52,1.76,1.76,0,0,1,.34-.46,2.2,2.2,0,0,1,1.62-.66,2.33,2.33,0,0,1,1.11.25,2,2,0,0,1,.76.69,2.48,2.48,0,0,1,.37,1h-.94a1.48,1.48,0,0,0-.25-.57,1.21,1.21,0,0,0-.44-.37,1.4,1.4,0,0,0-1.11,0,1.11,1.11,0,0,0-.41.28,1.29,1.29,0,0,0-.3.62,7.68,7.68,0,0,0-.07,1.29c0,.33,0,.59,0,.78a3.61,3.61,0,0,0,.06.5,1.1,1.1,0,0,0,.11.36,1.43,1.43,0,0,0,.19.29,1.28,1.28,0,0,0,.4.27,1.45,1.45,0,0,0,.51.1,1.25,1.25,0,0,0,1-.44,1.41,1.41,0,0,0,.32-1v-.35h-1.32v-.79h2.25Z"
          />
          <path
            className="cls-2"
            d="M162.07,32.76h-.86l-2.84-4.34v4.34h-1V26.59h.87l2.85,4.33V26.59h.93Z"
          />
          <path
            className="cls-2"
            d="M169.36,32.76h-4V26.59h4v.84h-3v1.8h2.57v.83h-2.57v1.86h3Z"
          />
          <path
            className="cls-1"
            d="M60.54,16.86l-.38,2.59H49.83L51.93,5h3.73l-1.73,11.9Z"
          />
          <path
            className="cls-1"
            d="M74.7,5l-.37,2.58H68.47L68,10.69h5.09l-.37,2.59H67.61l-.49,3.58h7.13l-.36,2.59H63L65.12,5Z"
          />
          <path
            className="cls-1"
            d="M89.49,19.45H85.63l-.38-3.21H80.82l-1.46,3.21H75.57L82.91,5h3.93ZM85,14.2l-.69-5.54L81.79,14.2Z"
          />
          <path
            className="cls-1"
            d="M106,19.45h-4l-1.44-3a15.88,15.88,0,0,0-1.11-2.06,2.5,2.5,0,0,0-.83-.84,2.28,2.28,0,0,0-1-.17H97l-.92,6.09H92.43L94.53,5h5.65c2.06,0,3.46.45,4.19,1.36a4.53,4.53,0,0,1,1.11,2.93,3.52,3.52,0,0,1-.92,2.59A4.27,4.27,0,0,1,102,13a3.92,3.92,0,0,1,1.3,1.13,13.64,13.64,0,0,1,1.08,2ZM101.6,9.15A2,2,0,0,0,101,7.69a3.55,3.55,0,0,0-2.47-.62h-.57l-.61,4.18h1.46A3,3,0,0,0,101,10.6,2.05,2.05,0,0,0,101.6,9.15Z"
          />
          <path
            className="cls-1"
            d="M124.86,5l-2.17,14.49h-3.45l-5.66-8.72-1.33,8.72h-3.69L110.7,5h3.47l5.68,8.71L121.16,5Z"
          />
          <path className="cls-1" d="M133.43,5l-2.17,14.49h-3.71L129.7,5Z" />
          <path
            className="cls-1"
            d="M152.4,5l-2.16,14.49h-3.45l-5.67-8.72-1.33,8.72H136.1L138.24,5h3.48l5.67,8.71L148.7,5Z"
          />
          <path
            className="cls-1"
            d="M169.75,5.41l-.49,3.14a15.84,15.84,0,0,0-4.3-.64,6.79,6.79,0,0,0-3.36.74,4.58,4.58,0,0,0-1.94,1.85,4.71,4.71,0,0,0-.6,2.25,4,4,0,0,0,.42,1.79,3.42,3.42,0,0,0,1.25,1.34,3.63,3.63,0,0,0,2,.51,5.86,5.86,0,0,0,.94-.08,7.54,7.54,0,0,0,.79-.17L165,16l.29-1.93h-2.54l.38-2.59H169l-1,7c-.52.19-1,.37-1.6.54a15,15,0,0,1-1.86.44,11,11,0,0,1-2.06.19,9.18,9.18,0,0,1-2.77-.41A7,7,0,0,1,157.34,18a5.8,5.8,0,0,1-1.59-2.07,6.85,6.85,0,0,1-.56-2.84,10.78,10.78,0,0,1,.32-2.45,7.85,7.85,0,0,1,1.32-2.68,7.44,7.44,0,0,1,3-2.27A12.5,12.5,0,0,1,165,4.76,17.47,17.47,0,0,1,169.75,5.41Z"
          />
          <path
            className="cls-3"
            d="M39,20.53l.12.91c.08.58.18,1.17.28,1.78.81,4.13,1.63,8.88-.89,12.65-.2,1-1.88,1-1.88,1A51.09,51.09,0,0,1,26,37.28c-.67,0-1.33,0-2,0-2.63.11-5.25.43-7.87.57a19.8,19.8,0,0,1-9.28-.66,7.65,7.65,0,0,1-1.66-.85,6.17,6.17,0,0,1-2.78-4.74,8.38,8.38,0,0,0,1-.35,51,51,0,0,0,7.12-2.59l.11.23s2.35,6,8.33,5.71,12.44-4.16,19.7-13.88Z"
          />
          <path
            className="cls-3"
            d="M20.15,9.54c-5.6,1.38-9,5.75-9.22,12,0,0,0,.09.08.08,4.56-3.17,9.6-5.29,10.2-12.09A2.91,2.91,0,0,0,20.15,9.54Z"
          />
          <path
            className="cls-3"
            d="M37.46,12.13a40.84,40.84,0,0,1-3.56,5.33,39.9,39.9,0,0,1-4.29,4.69c-3.43,3.21-7.06,6-11.24,6.55-2.38.31-4.55-.19-5.58-1.13a25.14,25.14,0,0,0,5.5-3.64,20.11,20.11,0,0,0,3.8-3.8c1.36-1.87,3-4.35,2.83-7.28,0-.25,0-.37,0-.57A11.25,11.25,0,0,0,24,8.81c-.14-.45-.47-1-.65-1.48-1-2.61-2.41-4.82-5.58-3.94C10.26,5.48,5.05,14.08,7.54,23.29c-2.09.6-4.23,2-6.5,2.37-1-4.43-.42-8.72-.78-13.17A41.34,41.34,0,0,1,.06,7.3,3.34,3.34,0,0,1,.68,5.43a6.7,6.7,0,0,1,1.2-1.6A8.91,8.91,0,0,1,6.44,1.61c.59-.13,1.19-.22,1.81-.3A94.25,94.25,0,0,1,27.42.12L29,0a27.11,27.11,0,0,1,3.12,0,16.05,16.05,0,0,1,2.74.59,7.27,7.27,0,0,1,1.54.73,5.68,5.68,0,0,1,2.38,3,7.22,7.22,0,0,1,.36,1.49c-.16,1.3.05,2,0,3.33C39.07,9.18,38.41,10.33,37.46,12.13Z"
          />
          <rect
            className="cls-1"
            x="49.88"
            y="22.09"
            width="119.49"
            height="1.14"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "iscom"
    ) {
      return (
        <svg
          id="iscom"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 175.4 329.17"
          className="icon icon-pigier-white"
          style={{ fill: "#000000" }}
        >
          <path d="M134.73,11.57C134,11.14,116.43,1,97.16,1a51.7,51.7,0,0,0-6.53.4C73.06,3.63,58.75,15.23,51.36,33.22c-5,12.3-17.7,57.24,31,119.31,17.08,21.74,32.56,58.86,20,91.93-4.3,11.33-11.06,18.85-18.1,20.14a34.33,34.33,0,0,1-6.18.54c-13,0-25.11-6.71-25.23-6.78a2.65,2.65,0,0,0-3.61,1L40,275.44a2.67,2.67,0,0,0,1,3.63c.71.41,17.45,10,37.3,10a57.75,57.75,0,0,0,10.38-.92c15.59-2.85,28.77-15.68,36.16-35.19,10.52-27.77,9.85-72.61-23.59-115.18C68.82,96.51,65.66,61.4,73.5,42.3c4.07-9.94,11.23-16,20.15-17.18a28,28,0,0,1,3.6-.22c12.43,0,25.29,7.26,25.42,7.33h0a2.67,2.67,0,0,0,3.63-1l4.68-8h0l4.7-8a2.62,2.62,0,0,0,.28-2A2.67,2.67,0,0,0,134.73,11.57Z" />
          <path d="M228.78,259.59a2.68,2.68,0,0,0-3.68-.63,38.7,38.7,0,0,1-19.76,5.94,29.94,29.94,0,0,1-3.43-.2c-21.51-2.46-34.35-47.15-34.35-119.56,0-75.88,12.28-118.72,34.57-120.64,11.85-1,21.3,6.31,21.38,6.38a2.67,2.67,0,0,0,3.72-.41L239,16.05a2.64,2.64,0,0,0-.37-3.73C238,11.83,224,.49,204.4.49c-1.43,0-2.88.06-4.31.18-20.28,1.75-35.22,16.17-44.42,42.86-8.09,23.48-12,56.72-12,101.61,0,90.88,18.69,139.11,55.55,143.33a54.72,54.72,0,0,0,6.15.35A62.66,62.66,0,0,0,239,278.43a2.66,2.66,0,0,0,.6-3.71Z" />
          <path d="M289.56.77c-20.47,0-36,14.06-41.61,37.63-4.9,20.64-8.63,86.34-8.63,106.74,0,15.1,1.47,77.22,8.68,105.3,6.59,25.64,20.43,38.65,41.15,38.65,21.17,0,36.62-14.73,41.32-39.39,4.2-22,6.52-75.82,6.52-104.56,0-27.25-1.94-86.53-6.62-106.68C324.89,14.85,309.63.77,289.56.77Zm-.41,264.39c-6.13,0-13.08-1.59-18-20.67-5.93-23.11-7.93-77.9-7.93-99.35,0-21.67,3.78-83.49,8-101.22,3-12.76,9.2-19.24,18.34-19.24,8.3,0,14.68,7,17.51,19.19,3.86,16.64,6,70.44,6,101.27,0,28.42-2.32,80.24-6.1,100.08C304.45,258.46,298.45,265.16,289.15,265.16Z" />
          <path d="M461.44,2.53A2.66,2.66,0,0,0,458.78,0H440.06a2.66,2.66,0,0,0-2.63,2.3L413,216.33,388.08,2.3A2.66,2.66,0,0,0,385.44,0H366.73a2.65,2.65,0,0,0-2.65,2.52L349.21,286.18a2.67,2.67,0,0,0,.72,2,2.7,2.7,0,0,0,1.93.82h18.63a2.64,2.64,0,0,0,2.65-2.51l6.69-181.15,22.31,181.35a2.67,2.67,0,0,0,2.64,2.31h15.84a2.65,2.65,0,0,0,2.63-2.29l23.37-179.4,4.85,179.15a2.65,2.65,0,0,0,2.65,2.54h18.62a2.65,2.65,0,0,0,2.66-2.78Z" />
          <path d="M21.27.27H2.66A2.66,2.66,0,0,0,0,2.93V30.46a2.66,2.66,0,0,0,2.66,2.66h.23L21.5,31.48a2.66,2.66,0,0,0,2.42-2.65V2.93A2.66,2.66,0,0,0,21.27.27Z" />
          <path d="M21,50.2,2.43,51.83A2.65,2.65,0,0,0,0,54.47V286.52a2.65,2.65,0,0,0,2.66,2.65H21.27a2.65,2.65,0,0,0,2.65-2.65V52.85a2.64,2.64,0,0,0-.86-2A2.58,2.58,0,0,0,21,50.2Z" />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "mbway"
    ) {
      return (
        <svg
          id="mbway"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 158.11 57.4"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <path d="M36.37,0c-2.55,0-4.17,1.68-5,3.92L20.7,32.37,10.2,4C9.33,1.55,7.83.06,5.16.06,1.87.06,0,2.43,0,5.59V41.47H5.78V9.08L16.66,37.34c.75,2,1.55,4.1,4.1,4.1s3.55-2.11,4.36-4.29L35.75,9.08V41.47h5.78V5.78C41.53,2.55,39.79,0,36.37,0M153.14,17.36V36.21c-.07.64,0,.73-.59.78h-7.29c-1.9-.06-2.65-.85-2.71-2.77V17.36h-5v18a6.22,6.22,0,0,0,2,4.91A6,6,0,0,0,144.37,42h8.77V55h5V17.36Zm-25.86,0H113.79v4.91h12.92c2.27.07,2.5.92,2.64,2.92h-9.21a6.6,6.6,0,0,0-4.69,1.68,6.33,6.33,0,0,0-1.75,4.68V35.8a5.72,5.72,0,0,0,2,4.59,7.23,7.23,0,0,0,4.73,1.53h7.75c3.76,0,6.15-2.68,6.17-6.36V23.8a6.12,6.12,0,0,0-2-4.91,7.58,7.58,0,0,0-5.07-1.53m2.05,17.4c0,1.52-.83,2.14-2.38,2.19h-5.81a2.23,2.23,0,0,1-2.48-2.24V32.4c.07-1.78.67-2.41,2.43-2.48h7.75c.49.07.45,0,.49.31Zm-26.76-.62L99.32,20.49C99,19,98.08,17.16,96,17.16s-3,1.8-3.33,3.32L89.37,34.15l-4.12-16.8H80.41l5.08,21c.41,1.73,1.44,3.56,3.7,3.56s3.33-1.65,3.7-3.43l3-13.09,3.15,13.1c.36,1.7,1.46,3.42,3.61,3.42h0c2.23,0,3.32-1.78,3.73-3.56l5.12-21h-4.84ZM73.18,20.77c3.54-2.05,4-4,4-8V9.39C77.22,3.3,74.73,0,68.39,0H47.57V41.47H68.39c6,0,8.89-3.73,8.89-9.51V29.35c0-2.43-.12-5.66-2.11-7.4a8,8,0,0,0-2-1.18M71.25,30.9c0,3.05-1.68,4.54-4.66,4.54h-13V23.75h13c2.92,0,4.66,1.31,4.66,4.35Zm.06-17.41c0,3-1.92,4.29-4.78,4.29H53.66V6H66.34c2.92,0,5,1.24,5,4.41Z" />
          <polygon points="5.91 54.91 5.91 48.96 3.77 53.68 3.05 53.68 0.87 48.96 0.87 54.91 0.04 54.91 0.04 47.08 0.87 47.08 3.43 52.63 5.91 47.08 6.75 47.08 6.75 54.91 5.91 54.91" />
          <path d="M11.67,52.41H10.16c-.81,0-1.22.32-1.22,1s.39.93,1.26.93a1.64,1.64,0,0,0,1.2-.37,1.26,1.26,0,0,0,.27-.93Zm0,2.5v-.52a1.93,1.93,0,0,1-1.56.59,1.9,1.9,0,0,1-1.53-.5,1.49,1.49,0,0,1-.41-1.1c0-1,.67-1.56,1.88-1.56h1.62V51.3c0-.78-.38-1.19-1.39-1.19a1.45,1.45,0,0,0-1.36.63l-.54-.49a2.08,2.08,0,0,1,1.92-.82c1.46,0,2.16.64,2.16,1.81v3.67Z" />
          <path d="M17.58,54.91V51.58a1.26,1.26,0,0,0-1.33-1.44,1.27,1.27,0,0,0-1.34,1.44v3.33h-.8V49.5h.8v.59a1.93,1.93,0,0,1,1.51-.66,1.9,1.9,0,0,1,1.39.51,2,2,0,0,1,.56,1.5v3.47Z" />
          <path d="M23.1,52.41H21.59c-.82,0-1.22.32-1.22,1s.38.93,1.25.93a1.63,1.63,0,0,0,1.2-.37A1.22,1.22,0,0,0,23.1,53Zm0,2.5v-.52a1.94,1.94,0,0,1-1.57.59,1.92,1.92,0,0,1-1.53-.5,1.52,1.52,0,0,1-.4-1.1c0-1,.67-1.56,1.88-1.56H23.1V51.3c0-.78-.39-1.19-1.39-1.19a1.46,1.46,0,0,0-1.37.63l-.53-.49a2.07,2.07,0,0,1,1.91-.82c1.46,0,2.17.64,2.17,1.81v3.67Z" />
          <path d="M27.4,50.13c-1.18,0-1.35,1-1.35,2s.17,2,1.35,2,1.34-1,1.34-2-.16-2-1.34-2m-.12,7.27a2.38,2.38,0,0,1-1.84-.73l.52-.5a1.67,1.67,0,0,0,1.3.54c1,0,1.48-.74,1.48-1.67V54.2a1.74,1.74,0,0,1-1.52.7,1.9,1.9,0,0,1-1.31-.48,3.12,3.12,0,0,1-.66-2.26,3.12,3.12,0,0,1,.66-2.26,1.92,1.92,0,0,1,1.32-.47,1.7,1.7,0,0,1,1.52.7V49.5h.78v5.58a2.15,2.15,0,0,1-2.25,2.32" />
          <path d="M34.43,50.92a1.39,1.39,0,0,0-2.53,0,2,2,0,0,0-.16.9h2.87a2.17,2.17,0,0,0-.18-.9m-2.69,1.49c0,1.19.55,1.87,1.59,1.87a1.77,1.77,0,0,0,1.42-.61l.54.47a2.5,2.5,0,0,1-2,.84c-1.44,0-2.37-.86-2.37-2.78,0-1.76.85-2.77,2.23-2.77s2.22,1,2.22,2.63v.35Z" />
          <path d="M43.76,54.91V51.58a1.35,1.35,0,1,0-2.69-.09v3.42h-.79V51.58A1.26,1.26,0,0,0,39,50.14a1.28,1.28,0,0,0-1.36,1.44v3.33H36.8V49.5h.79v.59a2,2,0,0,1,1.53-.66,1.79,1.79,0,0,1,1.66.9,2.1,2.1,0,0,1,1.79-.9,2,2,0,0,1,1.4.51,2,2,0,0,1,.58,1.5v3.47Z" />
          <path d="M49.39,50.92a1.39,1.39,0,0,0-2.53,0,2.18,2.18,0,0,0-.17.9h2.88a2.34,2.34,0,0,0-.18-.9m-2.7,1.49c0,1.19.55,1.87,1.6,1.87a1.77,1.77,0,0,0,1.42-.61l.54.47a2.5,2.5,0,0,1-2,.84c-1.44,0-2.37-.86-2.37-2.78,0-1.76.85-2.77,2.23-2.77s2.22,1,2.22,2.63v.35Z" />
          <path d="M55.22,54.91V51.58a1.25,1.25,0,0,0-1.33-1.44,1.27,1.27,0,0,0-1.34,1.44v3.33h-.79V49.5h.79v.59a1.94,1.94,0,0,1,1.52-.66,1.91,1.91,0,0,1,1.39.51,2,2,0,0,1,.56,1.5v3.47Z" />
          <path d="M59.19,54.91a1.33,1.33,0,0,1-1.39-1.45V50.1h-.68v-.6h.68V47.83h.79V49.5h1.16v.6H58.59v3.34c0,.49.23.79.74.79h.42v.68Z" />
          <path d="M66,47.72a.88.88,0,0,0-.91.92c0,.36.19.66.71,1.29l.42-.29c.36-.25.7-.53.7-1a.92.92,0,0,0-.92-.94m-.42,3.16c-.67.47-1.35.91-1.35,1.8a1.54,1.54,0,0,0,1.66,1.56,2.56,2.56,0,0,0,1.84-.76Zm3.33,4-.7-.86a3.26,3.26,0,0,1-2.31.93,2.24,2.24,0,0,1-2.48-2.28c0-1.18.84-1.77,1.69-2.34a2.82,2.82,0,0,1-.84-1.71,1.72,1.72,0,0,1,3.43,0,1.68,1.68,0,0,1-.87,1.4l-.58.39,2,2.42a2.94,2.94,0,0,0,.44-1.8h.8a3.75,3.75,0,0,1-.73,2.4l1.2,1.44Z" />
          <path d="M77,51.29H74.82v2.87H77a1.44,1.44,0,1,0,0-2.87m-.09-3.47h-2v2.72h2c.87,0,1.55-.43,1.55-1.36s-.68-1.36-1.55-1.36M77,54.91H74V47.08h3a2.06,2.06,0,0,1,2.31,2.09,1.79,1.79,0,0,1-1.15,1.71,1.91,1.91,0,0,1,1.27,1.86A2.07,2.07,0,0,1,77,54.91" />
          <path d="M84.34,54.91v-.6a2,2,0,0,1-1.53.67,1.92,1.92,0,0,1-1.4-.51A2,2,0,0,1,80.86,53V49.5h.79v3.33c0,1,.51,1.44,1.32,1.44a1.28,1.28,0,0,0,1.36-1.44V49.5h.79v5.41Z" />
          <path d="M88.53,55a3,3,0,0,1-2.22-.78l.53-.53a2.22,2.22,0,0,0,1.68.63c.9,0,1.44-.32,1.44-1s-.26-.74-.9-.79l-.89-.08c-1.06-.09-1.62-.55-1.62-1.45s.82-1.59,2-1.59a3.12,3.12,0,0,1,1.95.58l-.52.52a2.28,2.28,0,0,0-1.44-.43c-.79,0-1.21.33-1.21.89s.3.73,1,.8l.85.07c.94.09,1.59.44,1.59,1.47S89.85,55,88.53,55" />
          <path d="M92,54.91h.79V49.5H92Zm0-7h.89v-.89H92Z" />
          <path d="M98,54.91V51.58a1.34,1.34,0,1,0-2.68,0v3.33h-.79V49.5h.79v.59a2,2,0,0,1,1.52-.66,1.91,1.91,0,0,1,1.39.51,2,2,0,0,1,.56,1.5v3.47Z" />
          <path d="M103.61,50.92a1.39,1.39,0,0,0-2.53,0,2.18,2.18,0,0,0-.17.9h2.88a2.34,2.34,0,0,0-.18-.9m-2.7,1.49c0,1.19.56,1.87,1.6,1.87a1.77,1.77,0,0,0,1.42-.61l.54.47a2.5,2.5,0,0,1-2,.84c-1.44,0-2.37-.86-2.37-2.78,0-1.76.85-2.77,2.23-2.77s2.22,1,2.22,2.63v.35Z" />
          <path d="M107.68,55a3,3,0,0,1-2.22-.78l.53-.53a2.24,2.24,0,0,0,1.68.63c.9,0,1.44-.32,1.44-1s-.26-.74-.9-.79l-.89-.08c-1.06-.09-1.62-.55-1.62-1.45s.83-1.59,2-1.59a3.08,3.08,0,0,1,2,.58l-.52.52a2.28,2.28,0,0,0-1.44-.43c-.79,0-1.21.33-1.21.89s.3.73,1,.8l.85.07c.94.09,1.59.44,1.59,1.47S109,55,107.68,55" />
          <path d="M112.81,55a3,3,0,0,1-2.22-.78l.53-.53a2.24,2.24,0,0,0,1.68.63c.9,0,1.44-.32,1.44-1s-.26-.74-.9-.79l-.89-.08c-1.06-.09-1.62-.55-1.62-1.45s.83-1.59,2-1.59a3.08,3.08,0,0,1,2,.58l-.52.52a2.28,2.28,0,0,0-1.44-.43c-.79,0-1.21.33-1.21.89s.3.73,1,.8l.85.07c.94.09,1.59.44,1.59,1.47s-.88,1.65-2.2,1.65" />
          <path d="M120.91,55a3.39,3.39,0,0,1-2.67-1l.56-.56a2.69,2.69,0,0,0,2.14.85c1.15,0,1.86-.53,1.86-1.45a1.24,1.24,0,0,0-.39-1,1.68,1.68,0,0,0-1-.39l-.92-.13a2.84,2.84,0,0,1-1.43-.59,1.9,1.9,0,0,1-.6-1.48A2.21,2.21,0,0,1,121,47a3.16,3.16,0,0,1,2.33.86l-.54.54a2.4,2.4,0,0,0-1.83-.69,1.46,1.46,0,0,0-1.66,1.47,1.16,1.16,0,0,0,.35.91,2.19,2.19,0,0,0,1,.41l.91.14a2.34,2.34,0,0,1,1.42.56,2,2,0,0,1,.66,1.54c0,1.38-1.07,2.23-2.71,2.23" />
          <path d="M127.06,55c-1.37,0-2.4-.93-2.4-2.78s1-2.77,2.4-2.77a2.16,2.16,0,0,1,1.78.8l-.54.51a1.5,1.5,0,0,0-1.24-.61,1.48,1.48,0,0,0-1.26.62,2.34,2.34,0,0,0-.35,1.45,2.37,2.37,0,0,0,.35,1.46,1.59,1.59,0,0,0,2.5,0l.54.51a2.14,2.14,0,0,1-1.78.81" />
          <path d="M133.54,54.91V51.57c0-1-.5-1.43-1.32-1.43a1.26,1.26,0,0,0-1.36,1.43v3.34h-.79V47.08h.79v3a2,2,0,0,1,1.52-.66,1.83,1.83,0,0,1,2,2v3.48Z" />
          <path d="M138.9,50.53a1.4,1.4,0,0,0-1-.4,1.34,1.34,0,0,0-1,.4,2.34,2.34,0,0,0-.44,1.67,2.33,2.33,0,0,0,.44,1.68,1.33,1.33,0,0,0,1,.39,1.39,1.39,0,0,0,1-.39,2.42,2.42,0,0,0,.43-1.68,2.38,2.38,0,0,0-.43-1.67m.56,3.83a2.25,2.25,0,0,1-3.1,0,2.91,2.91,0,0,1-.66-2.16,2.88,2.88,0,0,1,.66-2.15,2.25,2.25,0,0,1,3.1,0,2.88,2.88,0,0,1,.66,2.15,2.91,2.91,0,0,1-.66,2.16" />
          <path d="M144.46,50.53a1.4,1.4,0,0,0-1-.4,1.34,1.34,0,0,0-1,.4,2.34,2.34,0,0,0-.44,1.67,2.33,2.33,0,0,0,.44,1.68,1.33,1.33,0,0,0,1,.39,1.39,1.39,0,0,0,1-.39,2.42,2.42,0,0,0,.43-1.68,2.38,2.38,0,0,0-.43-1.67m.56,3.83a2.06,2.06,0,0,1-1.55.62,2.1,2.1,0,0,1-1.56-.62,2.91,2.91,0,0,1-.66-2.16,2.88,2.88,0,0,1,.66-2.15,2.1,2.1,0,0,1,1.56-.62,2.06,2.06,0,0,1,1.55.62,2.88,2.88,0,0,1,.66,2.15,2.91,2.91,0,0,1-.66,2.16" />
          <path d="M148.45,54.91a1.29,1.29,0,0,1-1.37-1.44V47.08h.79v6.36c0,.53.18.79.73.79H149v.68Z" />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "espl"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 155.03 154.9"
          className="icon icon-pigier-white"
        >
          <g id="Calque_8" data-name="Calque 8">
            <path
              className="cls-1"
              d="M155,1570.37a49.12,49.12,0,0,1-49.12,49.12H0V1513.7a49.12,49.12,0,0,1,49.12-49.12H155Z"
              transform="translate(0 -1464.58)"
              fill="#e30613"
            />
            <text
              className="cls-2"
              transform="translate(35.59 95.5)"
              style={{
                fontSize: "39.23px",
                fontFamily: "CoolveticaRg-Regular, Coolvetica"
              }}
              fill="#ffffff"
            >
              ESPL
            </text>
            <path
              className="cls-3"
              d="M101.65,1523l-.45-2.1s10.77-2.65,17.59,3l-2.32,2s-2.35-1.55-7-.78c0,0,6.37.51,10.21,5.24l-1.85,1.2s-2-2.46-6.77-3.37a15.68,15.68,0,0,1,4.85,3.8l-1,1.78a14.39,14.39,0,0,0-12.74-3.95l.19-1.75a11.51,11.51,0,0,1,6.46-.54,9.44,9.44,0,0,0-4.61-1.46l-.22-1.53a25.92,25.92,0,0,1,9.37-.68S109.1,1521.71,101.65,1523Z"
              transform="translate(0 -1464.58)"
              fill="#ffffff"
            />
          </g>
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "mydigitaluniversity"
    ) {
      return (
        <svg
          id="mydigitaluniversity"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 420.44 152.06"
          className="icon icon-pigier-white"
          style={{ fill: "#000" }}
        >
          <path
            className="cls-1"
            d="M116,93.38V85.22q0-4.75-4.66-4.76h-1.66q-4.55,0-4.55,4.76v13.2a3.89,3.89,0,0,0,.89,3,22.71,22.71,0,0,0,2.88,2L119,108.84a48.15,48.15,0,0,1,4.72,2.94,7.55,7.55,0,0,1,2.16,2.55q.77,1.5.77,5.71v17q0,13.41-12.86,13.41h-6.54q-12.75,0-12.75-14.63v-4h10.64v4.33q0,4.65,4.77,4.65h1.89c2.8,0,4.21-1.55,4.21-4.65V122.59a3.89,3.89,0,0,0-.89-3,21.71,21.71,0,0,0-2.88-2L102.12,112a31.2,31.2,0,0,1-4.82-3,6.84,6.84,0,0,1-2.17-3.16,16,16,0,0,1-.66-5V84.45q0-13.65,12.75-13.64h6.65q12.75,0,12.75,13.64v8.93Z"
          />
          <path
            className="cls-1"
            d="M168.09,131.79v5.1q0,13.53-12.75,13.53h-6.88q-12.75,0-12.75-13.53V84.34q0-13.53,12.75-13.53h6.88q12.75,0,12.75,13.53v9H157.44V85.11q0-4.65-4.76-4.65h-2.11q-4.22,0-4.21,4.65v51q0,4.65,4.21,4.65h2.66q4.22,0,4.21-4.65v-4.33Z"
          />
          <path
            className="cls-1"
            d="M201.1,150.42V115.55H188v34.87H177.37V70.81H188V105.9H201.1V70.81h10.64v79.61Z"
          />
          <path
            className="cls-1"
            d="M234.22,150.42q-12.85,0-12.86-13.53V84.45q0-13.65,12.75-13.64h10.2q12.75,0,12.75,13.64v52.44q0,13.53-12.86,13.53Zm2.55-9.65h5.44c2.8,0,4.21-1.55,4.21-4.65v-51q0-4.65-4.77-4.65h-5c-3.1,0-4.66,1.55-4.66,4.65v51Q232,140.77,236.77,140.77Z"
          />
          <path
            className="cls-1"
            d="M279.74,150.42q-12.86,0-12.86-13.53V84.45q0-13.65,12.75-13.64h10.2q12.75,0,12.75,13.64v52.44q0,13.53-12.86,13.53Zm2.55-9.65h5.44c2.8,0,4.21-1.55,4.21-4.65v-51q0-4.65-4.77-4.65h-5c-3.1,0-4.66,1.55-4.66,4.65v51Q277.52,140.77,282.29,140.77Z"
          />
          <path className="cls-1" d="M333.28,150.42H312V70.81h10.65v70h10.66Z" />
          <path
            className="cls-1"
            d="M110.68,31.41l8.28-30h8V61.31h-8V24.6l-4.64,14.24h-7.23L102.45,24.6V61.31h-8V1.45h7.09Z"
          />
          <path
            className="cls-1"
            d="M150.43,1.45h7.09l-9.68,39.48V61.31H140V40.93L130,1.45h7.06l6.84,30Z"
          />
          <path
            className="cls-1"
            d="M167.6,61.31V1.45h13.92q11.26,0,11.26,11.51V52.64q0,8.67-9.59,8.67Zm8-7.25h6c2.11,0,3.17-.89,3.17-2.67V13q0-4.33-3.59-4.33H175.6Z"
          />
          <path
            className="cls-1"
            d="M270.73,8.71v52.6h-8V8.71h-7.67V1.45H278.4V8.71Z"
          />
          <path
            className="cls-1"
            d="M288.72,61.31h-8V11.71q0-10.26,9.58-10.26h6q9.58,0,9.59,10.26v49.6h-8V35.37h-9.17Zm9.17-33.2V12.21c0-2.34-1.16-3.5-3.5-3.5h-2.17c-2.33,0-3.5,1.16-3.5,3.5v15.9Z"
          />
          <path className="cls-1" d="M327.89,61.31H312V1.45h8V54.06h7.93Z" />
          <path
            className="cls-1"
            d="M237.64,18.38V11.87q0-10.41-10.17-10.42H222q-9.25,0-9.26,10.26V51.23q0,10.08,9.26,10.08h15.67V28.11H225.2v7.16h4.44V54.06h-5.42q-3.51,0-3.51-4.33V13q0-4.33,3.51-4.33h2q3.42,0,3.42,4.33v5.34Z"
          />
          <rect className="cls-1" x="198.69" y="18.38" width="8" height="42.94" />
          <rect className="cls-1" x="198.68" y="1.45" width="8.01" height="7.25" />
          <path className="cls-1" d="M243.44,61.31V18.38h8V61.31Z" />
          <rect className="cls-1" x="243.43" y="1.45" width="8.01" height="7.25" />
          <path
            className="cls-1"
            d="M344.44,16.81C344.44,7.53,352.33,0,362.06,0a17.54,17.54,0,0,1,16.85,11.91,19.73,19.73,0,0,1,4.38-.5c10.59,0,19.18,8.19,19.18,18.29a17.72,17.72,0,0,1-.46,3.95,13.76,13.76,0,0,1,8.45,12.53,13.16,13.16,0,0,1-1.77,6.6,30.15,30.15,0,0,1,.23,47.59,13.11,13.11,0,0,1,1.54,6.16,13.76,13.76,0,0,1-8.64,12.61,17.89,17.89,0,0,1,.65,4.7c0,10.35-8.8,18.74-19.64,18.74a20.84,20.84,0,0,1-4.65-.55,17.67,17.67,0,0,1-16.12,10c-9.73,0-17.62-7.52-17.62-16.81Z"
          />
          <path
            className="cls-1"
            d="M76,16.81C76,7.53,68.11,0,58.38,0A17.54,17.54,0,0,0,41.53,11.91a19.73,19.73,0,0,0-4.38-.5C26.56,11.41,18,19.6,18,29.7a17.72,17.72,0,0,0,.46,3.95A13.76,13.76,0,0,0,10,46.18a13.16,13.16,0,0,0,1.77,6.6,30.15,30.15,0,0,0-.23,47.59A13.11,13.11,0,0,0,10,106.53a13.77,13.77,0,0,0,8.64,12.61,18.32,18.32,0,0,0-.65,4.7c0,10.35,8.8,18.74,19.64,18.74a20.84,20.84,0,0,0,4.65-.55,17.68,17.68,0,0,0,16.12,10c9.73,0,17.62-7.52,17.62-16.81Z"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "esicad"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 155.03 154.9"
          className="icon icon-pigier-white"
        >
          <g id="Calque_8" data-name="Calque 8">
            <path
              className="cls-1"
              d="M155,886.7a49.12,49.12,0,0,1-49.12,49.12H0V830a49.12,49.12,0,0,1,49.12-49.11H155Z"
              transform="translate(0 -780.92)"
              fill="#36a9e1"
            />
            <path
              className="cls-2"
              d="M56.37,836.64l3.74,3.73,6-6a20.79,20.79,0,0,1-6-1.45Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M61.52,841.78l3.73,3.74L80.76,830a20.67,20.67,0,0,1-11.92,4.44Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M21,876.4V851.17H39.54v4.41H26.13V861H38.48v4.45H26.13v6.5h14v4.48Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M55.31,858.62c-.26-2.58-1.82-3.84-5.05-3.84-2.92,0-4.48,1-4.48,3.08,0,1.44,1.18,2.43,3.91,3.08a46.82,46.82,0,0,1,7.49,2.2c2.28,1,4,2.51,4,6.53,0,4.83-4.33,7.6-9.54,7.6-7.29,0-11-2.88-11.21-8.43h5.09c0,2.54,2.36,4.18,5.44,4.18,3.3,0,5.09-1.33,5.09-3.38,0-1.68-.69-2.7-3.91-3.39-7.72-1.63-11.14-3-11.14-8.43,0-4.18,3.08-7.48,9.31-7.48s9.88,3.3,10.07,8.28Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M62.23,876.4V851.17h5.28V876.4Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M91.45,867.74c-1.06,5.73-5,9.53-10.86,9.53-6.62,0-11.67-4.52-11.67-13.18s4.52-13.75,11.74-13.75c6.31,0,10.3,4,10.79,9.11H86.17a5.68,5.68,0,0,0-5.47-4.56c-4.37,0-6.42,3.39-6.42,8.9s2,8.89,6.15,8.89c3.12,0,5-1.79,5.74-4.94Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M108.17,876.4l-1.59-5.21H97.27l-1.79,5.21H89.9l9-25.23H105l8.89,25.23Zm-6.27-19.57h0l-3.23,10h6.43Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
            <path
              className="cls-2"
              d="M114.9,876.4V851.17h9.76c6.84,0,11.71,4.67,11.71,12.35S132,876.4,125.46,876.4Zm9.5-4.29c4.6,0,6.57-2.89,6.57-8.59s-2-8-7-8H120v16.57Z"
              transform="translate(0 -780.92)"
              fill="#ffffff"
            />
          </g>
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "ihecf"
    ) {
      return (
        <svg
          id="ihecf"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 841.96 253.67"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <circle className="cls-1" cx="14.21" cy="14.21" r="14.21" />
          <circle className="cls-1" cx="71.06" cy="14.21" r="14.21" />
          <circle className="cls-1" cx="127.91" cy="14.21" r="14.21" />
          <circle className="cls-1" cx="184.75" cy="14.21" r="14.21" />
          <circle className="cls-1" cx="14.21" cy="71.06" r="14.21" />
          <circle className="cls-1" cx="71.06" cy="71.06" r="14.21" />
          <circle className="cls-1" cx="127.91" cy="71.06" r="14.21" />
          <circle className="cls-1" cx="184.75" cy="71.06" r="14.21" />
          <circle className="cls-1" cx="14.21" cy="127.91" r="14.21" />
          <circle className="cls-1" cx="71.06" cy="127.91" r="14.21" />
          <circle className="cls-1" cx="127.91" cy="127.91" r="14.21" />
          <circle className="cls-1" cx="184.75" cy="127.91" r="14.21" />
          <circle className="cls-1" cx="14.21" cy="184.75" r="14.21" />
          <circle className="cls-1" cx="71.06" cy="184.75" r="14.21" />
          <circle className="cls-1" cx="127.91" cy="184.75" r="14.21" />
          <circle className="cls-1" cx="184.75" cy="184.75" r="14.21" />
          <path
            className="cls-2"
            d="M316.13,0V85.27h71.06V0h28.42V199H387.19V113.69H316.13V199H287.71V0Z"
          />
          <path
            className="cls-2"
            d="M557.73,85.27v28.42H472.46v56.85h85.27V199H444V0H557.73V28.42H472.46V85.27Z"
          />
          <path
            className="cls-2"
            d="M614.58,149.22q0,21.32,21.31,21.32h64V199h-64q-49.74,0-49.74-49.74V49.74Q586.15,0,635.89,0h64V28.42h-64q-21.32,0-21.31,21.32Z"
          />
          <path
            className="cls-2"
            d="M842,85.27v28.42H756.69V199H728.27V0H842V28.42H756.69V85.27Z"
          />
          <rect className="cls-2" x="230.86" width="28.42" height="198.96" />
          <path className="cls-2" d="M3.35,223.53V247H0V223.53Z" />
          <path
            className="cls-2"
            d="M12.21,247H8.86V230.23H11.7l.51,1.67a5.68,5.68,0,0,1,4.18-1.67q5.87,0,5.86,5.86V247H18.91V236.09a2.22,2.22,0,0,0-2.52-2.51,9.4,9.4,0,0,0-4.18.83Z"
          />
          <path
            className="cls-2"
            d="M27.76,247v-3.35H35.3A1.47,1.47,0,0,0,37,242c0-1.23-.55-1.84-1.67-1.84H32.79q-5,0-5-4.86,0-5,5-5h7.53v3.35H32.79a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51H35.3q5,0,5,5.19,0,5-5,5Z"
          />
          <path
            className="cls-2"
            d="M51.69,241.11a2.22,2.22,0,0,0,2.51,2.51h1.68V247H54.2c-3.9,0-5.86-1.95-5.86-5.86v-7.53H45.83v-3.35h2.51v-5l3.35-1.67v6.7h4.19v3.35H51.69Z"
          />
          <path
            className="cls-2"
            d="M64.74,223.53v3.35H61.39v-3.35Zm0,6.7V247H61.39V230.23Z"
          />
          <path
            className="cls-2"
            d="M76.11,241.11a2.22,2.22,0,0,0,2.51,2.51h1.67V247H78.62q-5.87,0-5.86-5.86v-7.53H70.25v-3.35h2.51v-5l3.35-1.67v6.7h4.18v3.35H76.11Z"
          />
          <path
            className="cls-2"
            d="M95.85,230.23H99.2V247H96.35l-.5-1.67A5.71,5.71,0,0,1,91.66,247c-3.9,0-5.86-1.95-5.86-5.86V230.23h3.35v10.88a2.22,2.22,0,0,0,2.51,2.51,9.45,9.45,0,0,0,4.19-.83Z"
          />
          <path
            className="cls-2"
            d="M110.57,241.11a2.22,2.22,0,0,0,2.51,2.51h1.68V247h-1.68q-5.86,0-5.86-5.86v-7.53h-2.51v-3.35h2.51v-5l3.35-1.67v6.7h4.19v3.35h-4.19Z"
          />
          <path
            className="cls-2"
            d="M139.17,223.53h3.35V247h-2.85l-.5-1.67A5.7,5.7,0,0,1,135,247q-5.87,0-5.87-5.86v-5q0-5.86,5.87-5.86a5.7,5.7,0,0,1,4.18,1.67Zm0,19.26v-8.38a9.43,9.43,0,0,0-4.18-.83,2.22,2.22,0,0,0-2.52,2.51v5a2.22,2.22,0,0,0,2.52,2.51A9.43,9.43,0,0,0,139.17,242.79Z"
          />
          <path
            className="cls-2"
            d="M151.38,239.94v1.17a2.22,2.22,0,0,0,2.51,2.51h6.7V247h-6.7q-5.87,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.68c3.9,0,5.86,2,5.86,5.86v3.85Zm0-2.68h6.7v-1.17a2.22,2.22,0,0,0-2.51-2.51h-1.68a2.22,2.22,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M166.94,247v-3.35h7.53a1.48,1.48,0,0,0,1.68-1.67c0-1.23-.56-1.84-1.68-1.84H172q-5,0-5-4.86,0-5,5-5h7.53v3.35H172a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51h2.51q5,0,5,5.19,0,5-5,5Z"
          />
          <path
            className="cls-2"
            d="M197.21,223.53v10.05h8.37V223.53h3.35V247h-3.35V236.92h-8.37V247h-3.35V223.53Z"
          />
          <path
            className="cls-2"
            d="M224.49,236.92q0-3.34-3.35-3.34h-5v-3.35h5q6.71,0,6.7,6.69V247H225l-.5-1.67A5.71,5.71,0,0,1,220.3,247c-3.9,0-5.86-1.67-5.86-5s2-5,5.86-5a5.68,5.68,0,0,1,4.19,1.68Zm0,5.87v-1.68a9.31,9.31,0,0,0-4.19-.84c-1.67,0-2.51.56-2.51,1.68s.84,1.67,2.51,1.67A9.45,9.45,0,0,0,224.49,242.79Z"
          />
          <path
            className="cls-2"
            d="M243.4,230.23h3.34V247H243.9l-.5-1.67a5.72,5.72,0,0,1-4.19,1.67q-5.86,0-5.86-5.86V230.23h3.35v10.88a2.21,2.21,0,0,0,2.51,2.51,9.48,9.48,0,0,0,4.19-.83Z"
          />
          <path
            className="cls-2"
            d="M258.11,241.11a2.22,2.22,0,0,0,2.52,2.51h1.67V247h-1.67q-5.86,0-5.86-5.86v-7.53h-2.52v-3.35h2.52v-5l3.34-1.67v6.7h4.19v3.35h-4.19Z"
          />
          <path
            className="cls-2"
            d="M271.16,239.94v1.17a2.22,2.22,0,0,0,2.51,2.51h6.7V247h-6.7q-5.87,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.68c3.9,0,5.86,2,5.86,5.86v3.85Zm0-2.68h6.7v-1.17a2.22,2.22,0,0,0-2.51-2.51h-1.68a2.22,2.22,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M286.72,247v-3.35h7.53a1.47,1.47,0,0,0,1.67-1.67c0-1.23-.55-1.84-1.67-1.84h-2.51q-5,0-5-4.86,0-5,5-5h7.53v3.35h-7.53a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51h2.51q5,0,5,5.19,0,5-5,5Z"
          />
          <path
            className="cls-2"
            d="M327,233.58v3.34H317v6.7H327V247h-13.4V223.53H327v3.35H317v6.7Zm-8.37-11.73,1.5-5h3.52l-2.34,5Z"
          />
          <path
            className="cls-2"
            d="M338.41,241.11a2.22,2.22,0,0,0,2.51,2.51h1.68V247h-1.68q-5.87,0-5.86-5.86v-7.53h-2.51v-3.35h2.51v-5l3.35-1.67v6.7h4.19v3.35h-4.19Z"
          />
          <path
            className="cls-2"
            d="M358.15,230.23h3.35V247h-2.85l-.5-1.67A5.68,5.68,0,0,1,354,247q-5.87,0-5.87-5.86V230.23h3.35v10.88a2.22,2.22,0,0,0,2.52,2.51,9.4,9.4,0,0,0,4.18-.83Z"
          />
          <path
            className="cls-2"
            d="M377.06,223.53h3.35V247h-2.85l-.5-1.67a5.71,5.71,0,0,1-4.19,1.67q-5.87,0-5.86-5.86v-5q0-5.86,5.86-5.86a5.71,5.71,0,0,1,4.19,1.67Zm0,19.26v-8.38a9.45,9.45,0,0,0-4.19-.83,2.22,2.22,0,0,0-2.51,2.51v5a2.22,2.22,0,0,0,2.51,2.51A9.45,9.45,0,0,0,377.06,242.79Z"
          />
          <path
            className="cls-2"
            d="M389.27,239.94v1.17a2.21,2.21,0,0,0,2.51,2.51h6.7V247h-6.7q-5.86,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.67q5.87,0,5.86,5.86v3.85Zm0-2.68H396v-1.17a2.21,2.21,0,0,0-2.51-2.51h-1.67a2.21,2.21,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M404.82,247v-3.35h7.54A1.47,1.47,0,0,0,414,242c0-1.23-.56-1.84-1.67-1.84h-2.51q-5,0-5-4.86,0-5,5-5h7.53v3.35h-7.53a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51h2.51q5,0,5,5.19,0,5-5,5Z"
          />
          <path
            className="cls-2"
            d="M435.1,241.11a2.21,2.21,0,0,0,2.51,2.51h7.53V247h-7.53q-5.87,0-5.86-5.86V229.39q0-5.87,5.86-5.86h7.53v3.35h-7.53a2.21,2.21,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M464.05,242q0,5-5,5h-3.35q-5,0-5-5v-6.7q0-5,5-5H459q5,0,5,5ZM454,242a1.48,1.48,0,0,0,1.68,1.67H459A1.47,1.47,0,0,0,460.7,242v-6.7c0-1-.56-1.51-1.67-1.51h-3.35c-1.12,0-1.68.51-1.68,1.51Z"
          />
          <path
            className="cls-2"
            d="M472.41,230.23l.5,1.67c.56-1.11,1.67-1.67,3.35-1.67a4.74,4.74,0,0,1,4.29,2.17,5.86,5.86,0,0,1,4.42-2.17q6.36,0,6.36,5.86V247H488V236.09c0-1.68-1-2.51-2.86-2.51a3.23,3.23,0,0,0-3,1.67V247h-3.35V235.08a2.41,2.41,0,0,0-2.51-1.5c-1.68,0-2.79.55-3.35,1.67V247h-3.35V230.23Z"
          />
          <path
            className="cls-2"
            d="M500.19,253.67h-3.35V230.23h2.85l.5,1.34c.44-.9,1.56-1.34,3.35-1.34h1.67q5,0,5,5V242q0,5-5,5h-1.67c-1.79,0-2.91-.44-3.35-1.34Zm3.35-20.09c-1.79,0-2.91.28-3.35.83v8.38c.44.55,1.56.83,3.35.83h1.67a1.48,1.48,0,0,0,1.68-1.67v-6.7a1.48,1.48,0,0,0-1.68-1.67Z"
          />
          <path
            className="cls-2"
            d="M521.6,241.11a2.22,2.22,0,0,0,2.52,2.51h1.67V247h-1.67q-5.86,0-5.86-5.86v-7.53h-2.52v-3.35h2.52v-5l3.34-1.67v6.7h4.19v3.35H521.6Z"
          />
          <path
            className="cls-2"
            d="M541.35,236.92q0-3.34-3.35-3.34h-5v-3.35h5q6.69,0,6.7,6.69V247h-2.85l-.5-1.67a5.71,5.71,0,0,1-4.19,1.67q-5.86,0-5.86-5t5.86-5a5.68,5.68,0,0,1,4.19,1.68Zm0,5.87v-1.68a9.31,9.31,0,0,0-4.19-.84c-1.67,0-2.51.56-2.51,1.68s.84,1.67,2.51,1.67A9.45,9.45,0,0,0,541.35,242.79Z"
          />
          <path
            className="cls-2"
            d="M553.55,231.9a5.72,5.72,0,0,1,4.19-1.67q5.87,0,5.86,5.86v5q0,5.87-5.86,5.86a5.72,5.72,0,0,1-4.19-1.67l-.5,1.67h-2.84V223.53h3.34Zm4.19,11.72a2.22,2.22,0,0,0,2.51-2.51v-5a2.22,2.22,0,0,0-2.51-2.51,9.48,9.48,0,0,0-4.19.83v8.38A9.48,9.48,0,0,0,557.74,243.62Z"
          />
          <path className="cls-2" d="M572.46,223.53V247h-3.35V223.53Z" />
          <path
            className="cls-2"
            d="M581.32,239.94v1.17a2.22,2.22,0,0,0,2.51,2.51h6.7V247h-6.7q-5.87,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.68c3.9,0,5.86,2,5.86,5.86v3.85Zm0-2.68H588v-1.17a2.22,2.22,0,0,0-2.51-2.51h-1.68a2.22,2.22,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M596.88,247v-3.35h7.53a1.48,1.48,0,0,0,1.68-1.67c0-1.23-.56-1.84-1.68-1.84H601.9q-5,0-5-4.86,0-5,5-5h7.53v3.35H601.9a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51h2.51q5,0,5,5.19,0,5-5,5Z"
          />
          <path
            className="cls-2"
            d="M627.15,239.94v1.17a2.22,2.22,0,0,0,2.51,2.51h6.7V247h-6.7q-5.86,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.68c3.9,0,5.86,2,5.86,5.86v3.85Zm0-2.68h6.7v-1.17a2.22,2.22,0,0,0-2.51-2.51h-1.68a2.22,2.22,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M648.57,241.11a2.21,2.21,0,0,0,2.51,2.51h1.67V247h-1.67q-5.87,0-5.86-5.86v-7.53h-2.51v-3.35h2.51v-5l3.35-1.67v6.7h4.18v3.35h-4.18Z"
          />
          <path
            className="cls-2"
            d="M680.52,233.58v3.34h-10V247h-3.35V223.53h13.4v3.35h-10v6.7Z"
          />
          <path
            className="cls-2"
            d="M689.38,223.53v3.35H686v-3.35Zm0,6.7V247H686V230.23Z"
          />
          <path
            className="cls-2"
            d="M698.24,247h-3.35V230.23h2.84l.51,1.67a5.68,5.68,0,0,1,4.18-1.67q5.87,0,5.86,5.86V247h-3.35V236.09a2.21,2.21,0,0,0-2.51-2.51,9.4,9.4,0,0,0-4.18.83Z"
          />
          <path
            className="cls-2"
            d="M723.84,236.92q0-3.34-3.35-3.34h-5v-3.35h5q6.69,0,6.7,6.69V247h-2.85l-.5-1.67a5.71,5.71,0,0,1-4.19,1.67q-5.86,0-5.86-5t5.86-5a5.68,5.68,0,0,1,4.19,1.68Zm0,5.87v-1.68a9.31,9.31,0,0,0-4.19-.84c-1.67,0-2.51.56-2.51,1.68s.84,1.67,2.51,1.67A9.45,9.45,0,0,0,723.84,242.79Z"
          />
          <path
            className="cls-2"
            d="M736.05,247H732.7V230.23h2.85l.5,1.67a5.68,5.68,0,0,1,4.18-1.67q5.87,0,5.87,5.86V247h-3.35V236.09a2.22,2.22,0,0,0-2.52-2.51,9.4,9.4,0,0,0-4.18.83Z"
          />
          <path
            className="cls-2"
            d="M755,241.11a2.22,2.22,0,0,0,2.51,2.51h6.7V247h-6.7c-3.9,0-5.86-1.95-5.86-5.86v-5c0-3.91,2-5.86,5.86-5.86h6.7v3.35h-6.7a2.22,2.22,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M773,223.53v3.35h-3.35v-3.35Zm0,6.7V247h-3.35V230.23Z"
          />
          <path
            className="cls-2"
            d="M781.9,239.94v1.17a2.21,2.21,0,0,0,2.51,2.51h6.7V247h-6.7q-5.86,0-5.86-5.86v-5q0-5.86,5.86-5.86h1.67q5.86,0,5.86,5.86v3.85Zm2.34-11.39-2.34-5h3.51l1.51,5Zm-2.34,8.71h6.69v-1.17a2.21,2.21,0,0,0-2.51-2.51h-1.67a2.21,2.21,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M800.8,247h-3.35V230.23h2.85l.5,1.67a5.71,5.71,0,0,1,4.19-1.67h.83v3.35H805a9.45,9.45,0,0,0-4.19.83Z"
          />
          <path
            className="cls-2"
            d="M813.85,239.94v1.17a2.21,2.21,0,0,0,2.51,2.51h6.7V247h-6.7q-5.86,0-5.86-5.86v-5q0-5.86,5.86-5.86H818q5.87,0,5.86,5.86v3.85Zm0-2.68h6.7v-1.17a2.22,2.22,0,0,0-2.52-2.51h-1.67a2.21,2.21,0,0,0-2.51,2.51Z"
          />
          <path
            className="cls-2"
            d="M829.4,247v-3.35h7.54a1.47,1.47,0,0,0,1.67-1.67c0-1.23-.56-1.84-1.67-1.84h-2.51q-5,0-5-4.86,0-5,5-5H842v3.35h-7.53a1.48,1.48,0,0,0-1.68,1.67c0,1,.56,1.51,1.68,1.51h2.51q5,0,5,5.19,0,5-5,5Z"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "pigier"
    ) {
      return (
        <svg
          id="pigier"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 380.86 106.26"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <path
            className="cls-1"
            d="M5.81,29.73H23.6c10,0,18.14,7,18.14,17s-8.12,17-18.14,17H11.12v19.7H.5V54.21H23.6a7.52,7.52,0,0,0,0-15H.51V29.73Z"
          />
          <polygon
            className="cls-1"
            points="60.15 33.87 60.15 79.22 60.15 83.36 49.53 83.36 49.53 79.22 49.53 33.87 49.53 29.73 60.15 29.73 60.15 33.87 60.15 33.87"
          />
          <path
            className="cls-1"
            d="M140.32,33.87c0,24.24,0,38,0,45.35v4.14H129.69V79.22c0-7.38,0-21.11,0-45.35V29.73h10.62v4.14Z"
          />
          <path
            className="cls-1"
            d="M223,29.73c10,0,18.14,7,18.14,17s-8.12,17-18.14,17h-2l19.58,19.55h-15L204.07,61.73V54.21H223a7.52,7.52,0,0,0,0-15H204.07V29.73Z"
          />
          <path
            className="cls-1"
            d="M110.35,39.17H97a17.3,17.3,0,0,0,0,34.6H105v-9.9H92.43V54.43h23.23V83.21H97c-15.41,0-27.91-11.33-27.91-26.74S81.58,29.73,97,29.73h18.67v9.44Z"
          />
          <path
            className="cls-1"
            d="M188.09,39.17h-9a17.3,17.3,0,0,0,0,34.6h14.34v9.44H179.05c-15.42,0-27.91-11.33-27.91-26.74s12.49-26.74,27.91-26.74H193.4v9.44Z"
          />
          <polygon
            className="cls-1"
            points="158.81 54.43 186.01 54.43 191.33 54.43 191.33 63.88 186.01 63.88 158.81 63.88 153.5 63.88 153.5 54.43 158.81 54.43 158.81 54.43"
          />
          <path
            className="cls-2"
            d="M320.76,95.73a42.42,42.42,0,0,0,7.43.65A43,43,0,0,0,371,53.13a43.69,43.69,0,0,0-1.38-10.92h10.15a53.79,53.79,0,0,1,1.11,10.92c0,29.3-23.53,53.13-52.67,53.13a53.59,53.59,0,0,1-7.43-.52v-10Z"
          />
          <path
            className="cls-2"
            d="M324.56,9.89a43,43,0,0,0-42.79,43.24,43.68,43.68,0,0,0,1.72,12.19H273.28a53.72,53.72,0,0,1-1.4-12.19C271.88,23.83,295.42,0,324.56,0a53.18,53.18,0,0,1,6.83.44v10a42.82,42.82,0,0,0-6.83-.54Z"
          />
          <path
            className="cls-2"
            d="M331.39,35.48V84.73H320.76V26.25a48.23,48.23,0,0,1,6.25-.4c14.24,0,28.17,8.83,28.17,22.3S341.25,70.46,327,70.46s-28.17-8.84-28.17-22.31V41.83h9.29v6.32c0,6,7.13,13,18.88,13s18.88-7,18.88-13c0-5.25-5.38-11.2-14.5-12.67Z"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "pigierCreation"
    ) {
      return (
        <svg
          id="Calque_1"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 340.89 100.82"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <path
            className="cls-1"
            d="M113.17,0h16.76C139.37,0,147,6.55,147,16s-7.65,16-17.09,16H118.17V50.52h-10V23.07h21.76a7.09,7.09,0,1,0,0-14.17H108.17V0Z"
          />
          <path
            className="cls-1"
            d="M164.36,3.9V43.11c-1.71,2-6.89,6.15-10,7.41V0h10V3.9Z"
          />
          <path
            className="cls-1"
            d="M239.89,3.9c0,22.84,0,35.78,0,42.72v3.9h-10V0h10V3.9Z"
          />
          <path
            className="cls-1"
            d="M317.79,0c9.44,0,17.09,6.55,17.09,16s-7.65,16-17.09,16h-1.86l18.44,18.42H320.22L300,30.15V23.07h17.84a7.09,7.09,0,0,0,0-14.17H300V0Z"
          />
          <path
            className="cls-1"
            d="M211.66,8.9H199.07a16.3,16.3,0,0,0,0,32.59h7.59V32.17H194.77v-8.9h21.89V50.39H199.07c-14.52,0-26.29-10.67-26.29-25.2S184.55,0,199.07,0h17.59V8.9Z"
          />
          <path
            className="cls-1"
            d="M284.89,8.9h-8.51a16.3,16.3,0,0,0,0,32.59h13.51v8.9H276.38c-14.53,0-26.3-10.67-26.3-25.2S261.85,0,276.38,0H289.9V8.9Z"
          />
          <polygon
            className="cls-1"
            points="257.31 23.27 282.94 23.27 287.94 23.27 287.94 32.17 282.94 32.17 257.31 32.17 252.31 32.17 252.31 23.27 257.31 23.27 257.31 23.27"
          />
          <path
            className="cls-2"
            d="M82.49,85.37c.85-.88,1.63-1.78,2.36-2.68l.29-.37c.26-.33.51-.67.75-1l.32-.44c.23-.33.46-.67.68-1l.25-.38c.29-.46.57-.92.83-1.39L88,78c.24-.44.47-.87.69-1.31l.21-.47c.15-.32.3-.64.43-1l.22-.52.36-1c0-.16.12-.32.17-.48.15-.47.3-.94.43-1.41l.06-.28c.09-.33.17-.66.24-1h0a1.55,1.55,0,0,0,0-.21c0-.16.06-.32.09-.48.07-.34.12-.68.17-1,0-.17,0-.34.07-.51,0-.36.08-.71.11-1.07l0-.46c0-.51,0-1,0-1.52q0-12.9-12.47-12.91-9.69,0-19.12,8.63c-.42.37-.82.75-1.21,1.13l-.39.39-.73.74-.43.47c-.21.22-.41.44-.61.67L56,65l-.54.65-.4.5-.48.65-.36.5c-.15.22-.3.43-.44.65l-.32.49c-.14.23-.28.46-.41.69s-.18.3-.26.45-.28.52-.41.78c-.05.1-.11.2-.16.31h0a.2.2,0,0,0,0,.08L52,71c-.11.24-.21.48-.31.72l-.17.41c-.08.2-.15.41-.22.61a4,4,0,0,0-.15.45,5.76,5.76,0,0,0-.18.59c0,.15-.09.3-.13.45s-.09.39-.14.59l-.09.45c0,.2-.07.41-.1.61s0,.28-.07.42,0,.46-.07.68l0,.35c0,.35,0,.69,0,1q0,4.89,4.29,4.89c3.12,0,4.69-1.51,4.69-4.52q0-3.37-3.32-3.37a5.26,5.26,0,0,0-3.25,1.47,1,1,0,0,1-.52.24c-.26,0-.39-.2-.39-.61a7.32,7.32,0,0,1,0-.81,2.11,2.11,0,0,1,0-.25c0-.19,0-.37.07-.56s0-.2.05-.3.07-.36.11-.54,0-.2.07-.3.11-.39.17-.59,0-.16.07-.25c.09-.26.18-.53.29-.79l.15-.36c.06-.15.13-.31.2-.46s.14-.3.22-.45l.2-.4.36-.64.22-.39.49-.75.18-.28c.24-.34.49-.69.76-1l.2-.25c.21-.27.42-.54.65-.8l.34-.4.6-.67.41-.44.63-.65.44-.43.74-.71.4-.38c.4-.36.81-.73,1.23-1.09q9.38-8.09,17.5-8.08a11.52,11.52,0,0,1,8.12,2.81,9.81,9.81,0,0,1,3,7.59c0,.49,0,1-.07,1.48l0,.41c0,.44-.1.89-.18,1.34,0,.06,0,.12,0,.17-.09.5-.21,1-.33,1.5,0,.13-.07.27-.11.41-.12.43-.25.86-.39,1.3a2.5,2.5,0,0,1-.09.25c-.15.45-.32.91-.51,1.36l-.15.35c-.15.35-.3.69-.47,1-.07.16-.14.31-.22.47l-.5,1-.24.44c-.23.41-.47.82-.72,1.24l-.1.17c-.29.47-.6.94-.92,1.42l-.27.38-.75,1.06-.36.47c-.25.34-.52.69-.8,1-.11.14-.22.29-.34.43-.39.48-.8,1-1.22,1.45Q66.51,99.66,48,99.65q-9.83,0-15.54-5T26.81,81c0-.49,0-1,0-1.46,0-.15,0-.3,0-.45,0-.34.05-.68.08-1l.06-.53c0-.33.08-.66.12-1,0-.17.05-.33.07-.5.07-.41.14-.82.22-1.24,0-.08,0-.16,0-.24.1-.48.21-1,.33-1.46l.12-.47c.09-.35.19-.69.29-1,.05-.17.1-.35.16-.52s.18-.56.27-.84.26-.76.4-1.14l.26-.69q.24-.63.51-1.26l.24-.57c.27-.6.55-1.21.85-1.82l.12-.25c.27-.53.55-1.06.84-1.6l.34-.61c.23-.42.47-.83.72-1.25l.42-.69c.24-.4.5-.81.76-1.21l.44-.69.89-1.29.41-.59c.45-.62.91-1.25,1.39-1.88.87.08,1.88.12,3.06.12q12.54,0,28.74-4.77T94.72,38.61q4.55,6.3,4.54,12.42c0,1.34.26,2,.78,2s1-.52,1-1.53q0-6.24-5.32-13.64,5.86-4.29,5.86-8.26,0-6-12.93-6a41.75,41.75,0,0,0-7.87.74q-22.23-13.63-44-13.64-15.6,0-26.08,6.42T.19,33.1q0,16,28.13,20.92c-.44.63-.86,1.26-1.26,1.88-.1.15-.19.3-.29.44-.39.62-.77,1.23-1.12,1.84l-.13.23c-.31.55-.61,1.1-.9,1.66l-.23.44c-.3.59-.58,1.19-.85,1.79l-.15.36c-.23.51-.43,1-.63,1.53-.06.15-.12.29-.17.44-.21.58-.41,1.16-.59,1.74-.05.15-.09.3-.14.46-.15.49-.28,1-.4,1.46,0,.14-.07.27-.1.41-.13.57-.25,1.14-.35,1.71,0,.07,0,.14,0,.21h0c0,.17,0,.33-.07.5s0,.33-.07.49-.07.54-.1.8,0,.3,0,.46-.05.6-.07.91c0,.11,0,.22,0,.33q0,.63,0,1.26a23.56,23.56,0,0,0,7.79,18,27.46,27.46,0,0,0,19.37,7.28q16.52,0,30-10.95c.53-.42,1-.85,1.52-1.27L79.7,88l1-.94.43-.41c.33-.33.66-.65,1-1ZM90.11,24.6q10.41,0,10.4,5,0,3.24-5.34,7.52a50.26,50.26,0,0,0-12.8-11.68A42.35,42.35,0,0,1,90.11,24.6ZM94.2,37.75q-9.63,6.68-26.15,11.38a111.29,111.29,0,0,1-30,4.65A76,76,0,0,1,57,36.47,78.3,78.3,0,0,1,80.75,25.7,48,48,0,0,1,94.2,37.75ZM2.46,34.27q0-8.19,10.28-14.32t24.13-6.11A86.66,86.66,0,0,1,78.93,24.6Q45.24,31.69,28.84,53.17,2.46,48.88,2.46,34.27Z"
          />
          <path
            className="cls-2"
            d="M160.61,55.79c6.54-2.57,6.71-2.23,10.92-5.33l-2.66-3.85c-4.34,5.3-8.26,7.26-16.52,11.57-.51.26-.78.42-.78.55a.54.54,0,0,0,.39.12C152.69,58.85,155.58,57.83,160.61,55.79Z"
          />
          <path
            className="cls-2"
            d="M242.87,58.92A5.89,5.89,0,0,0,247,57.08a5.61,5.61,0,0,0,2-4c0-1.76-.94-2.63-2.8-2.63A6.17,6.17,0,0,0,242,52.31a5.3,5.3,0,0,0-2,3.85C239.94,58,240.92,58.92,242.87,58.92Z"
          />
          <path
            className="cls-2"
            d="M340.32,78c-.22,0-.44.2-.65.61Q325.46,98,319.69,98c-1.78,0-2.67-.84-2.66-2.51s2-5.26,6.12-11,6-9.8,6-12.54a7.93,7.93,0,0,0-1.95-5.44,6.16,6.16,0,0,0-4.81-2.2q-3.51,0-7.67,3.67T302.93,81.6q4.88-7,4.88-10.88a6.92,6.92,0,0,0-1.55-4.53,4.76,4.76,0,0,0-3.78-1.89q-3.44,0-13.4,12.54l-1,1.19a2.82,2.82,0,0,0-.92.82A23,23,0,0,1,280.82,85c-2.6,1.72-4.88,2.57-6.83,2.57a5.81,5.81,0,0,1-2.92-.73Q278.95,77,279,69.93q0-5.62-5.59-5.63-6,0-15.22,6.18A40.76,40.76,0,0,0,249.35,78a1.2,1.2,0,0,0-.51.58Q234.26,98,228.47,98c-2,0-3.05-.92-3.05-2.75s1.06-4.35,3.19-7.65l14.77-22.81a40.84,40.84,0,0,1-4.94.43,16.67,16.67,0,0,1-3.18-.43l-8.39,13.39a2.12,2.12,0,0,0-.4.43Q212.42,98,206.49,98c-2,0-3.05-.92-3.05-2.75,0-1.67.89-3.92,2.67-6.73l14.52-23.3h8.52l.52-.92h-8.52l7.48-11.87a15.23,15.23,0,0,1-3.76.49,15,15,0,0,1-3.71-.49L213.54,64.3H207l-.65.92H213l-8.19,12.91a2.06,2.06,0,0,0-.4.48,107.74,107.74,0,0,1-11.65,13.82Q187.05,98,184.45,98c-1.69,0-2.53-1-2.53-2.88s2-6.13,6-12.41l11.52-17.92a32.15,32.15,0,0,1-4.55.43,16.78,16.78,0,0,1-3.45-.43l-3.31,5.93a10.28,10.28,0,0,0,.52-2.75q0-3.68-4-3.67-4.76,0-12.49,4Q161.71,73.69,157.46,80q-14.39,17.88-24.37,17.9c-4,0-6-1.76-6-5.26q0-4.23,4.43-10.52,14.29-2.7,20.42-5.75T158,68.83a3.88,3.88,0,0,0-1.68-3.19,6.07,6.07,0,0,0-4-1.34q-5.4,0-14,4.4-10.5,5.39-14.23,11.86-5.45,6.68-10.1,6.67c-2.73,0-4.1-1.71-4.09-5.13a15.6,15.6,0,0,1,.91-4.65l.78-.61q2.86-1.65,4.29-2.51,9-5.44,9-8.38c0-1.1-.67-1.65-2-1.65q-2.93,0-6.63,3.67a31,31,0,0,0-6.12,9.11,50.57,50.57,0,0,0-6.44,6q5.34-7.75,5.34-12.47,0-6.3-5.2-6.3-3.57,0-13.6,12.54l-1.17,1.53a.87.87,0,0,0-.26.48.33.33,0,0,0,.26.37c.31,0,.65-.28,1-.85q9.57-13.16,13.21-13.15c1,0,1.5.57,1.49,1.71q0,2.94-8,15.17L86.21,98.37c2.47-.17,3.79-.25,4-.25.39,0,1.73.08,4,.25q6.32-10.16,8.85-13.46a44.91,44.91,0,0,1,6.7-6.67,16,16,0,0,0-.78,4.35c0,3.59,1.64,5.38,4.94,5.38q4.23,0,9-4.87a14.43,14.43,0,0,0-.9,5,10.61,10.61,0,0,0,3,7.77,10.5,10.5,0,0,0,7.66,3.06q9.51,0,22.76-15.27a15.18,15.18,0,0,0-1,5.48,10.54,10.54,0,0,0,2.33,7,7.3,7.3,0,0,0,5.79,2.76c2.16,0,4.4-1,6.7-3s5.61-5.85,9.95-11.56a15.16,15.16,0,0,0-2.08,7.15,7.75,7.75,0,0,0,1.88,5.33,6.25,6.25,0,0,0,4.87,2.08c2.95,0,7-2.89,12.1-8.69,1.79-2,3.31-3.72,4.59-5.21a15,15,0,0,0-2,6.62,7.14,7.14,0,0,0,2,5.2,7,7,0,0,0,5.14,2.08q5.94,0,17.5-14.79c-1.77,3.27-2.67,5.81-2.67,7.63a6.9,6.9,0,0,0,7.14,7.16q6.33,0,18.26-15.44a14,14,0,0,0-1,5.16,10.54,10.54,0,0,0,2.73,7.28,8.82,8.82,0,0,0,6.69,3q7.54,0,16.14-11.44a8.22,8.22,0,0,0,3.57.73q4.81,0,10.54-5.38a26.6,26.6,0,0,0,3.41-3.65,2.56,2.56,0,0,0,.82-.81Q298.65,65.21,302,65.22c1.09,0,1.63.61,1.63,1.83q0,3.24-8.66,16.21L284.78,98.37a34.17,34.17,0,0,1,4.29-.25c.43,0,1.71.08,3.83.25q19.8-33.15,29.28-33.15c1.87,0,2.8.83,2.8,2.5q0,2-5.27,9.36a94.82,94.82,0,0,0-6.32,9.36,11.12,11.12,0,0,0-1.17,5.07,7.45,7.45,0,0,0,1.95,5.27,6.52,6.52,0,0,0,4.93,2.14c2.95,0,7-2.89,12.17-8.69q9.44-10.58,9.44-11.86C340.71,78.12,340.58,78,340.32,78ZM143,69.62q5.67-4.53,9.11-4.53c1.52,0,2.28.66,2.27,2q0,3.67-6.5,7.83A53.15,53.15,0,0,1,132,81.24,64.42,64.42,0,0,1,143,69.62ZM178.61,84q-11.06,14-15.55,14c-2.51,0-3.77-1.33-3.76-4q0-6.8,9.7-17.8t15.74-11c1.95,0,2.92,1,2.92,3Q187.66,72.5,178.61,84ZM268,83a5.84,5.84,0,0,0,1.88,4q-8.33,10.89-15.35,10.89-4.29,0-4.28-4.22,0-7.29,8.52-17.92t14.45-10.65c3.16,0,4.74,1.66,4.74,5a10.83,10.83,0,0,1-1,4.77,1.49,1.49,0,0,0-1.43-1.23q-2.42,0-4.95,3.19A10,10,0,0,0,268,83Z"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "pigierPerformance"
    ) {
      return (
        <svg
          id="Calque_1"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 380.86 123.6"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <path
            className="cls-1"
            d="M5.81,29.73H23.6c10,0,18.14,7,18.14,17s-8.12,17-18.14,17H11.12v19.7H.5V54.21H23.6a7.52,7.52,0,0,0,0-15H.51V29.73Z"
          />
          <polygon
            className="cls-1"
            points="60.15 33.87 60.15 79.22 60.15 83.36 49.53 83.36 49.53 79.22 49.53 33.87 49.53 29.73 60.15 29.73 60.15 33.87 60.15 33.87"
          />
          <path
            className="cls-1"
            d="M140.32,33.87c0,24.24,0,38,0,45.35v4.14H129.69V79.22c0-7.38,0-21.11,0-45.35V29.73h10.62v4.14Z"
          />
          <path
            className="cls-1"
            d="M223,29.73c10,0,18.14,7,18.14,17s-8.12,17-18.14,17h-2l19.58,19.55h-15L204.07,61.73V54.21H223a7.52,7.52,0,0,0,0-15H204.07V29.73Z"
          />
          <path
            className="cls-1"
            d="M110.35,39.17H97a17.3,17.3,0,0,0,0,34.6H105v-9.9H92.43V54.43h23.23V83.21H97c-15.41,0-27.91-11.33-27.91-26.74S81.58,29.73,97,29.73h18.67v9.44Z"
          />
          <path
            className="cls-1"
            d="M188.09,39.17h-9a17.3,17.3,0,0,0,0,34.6h14.34v9.44H179.05c-15.42,0-27.91-11.33-27.91-26.74s12.49-26.74,27.91-26.74H193.4v9.44Z"
          />
          <polygon
            className="cls-1"
            points="158.81 54.43 186.01 54.43 191.33 54.43 191.33 63.88 186.01 63.88 158.81 63.88 153.5 63.88 153.5 54.43 158.81 54.43 158.81 54.43"
          />
          <path
            className="cls-2"
            d="M320.76,95.73a42.42,42.42,0,0,0,7.43.65A43,43,0,0,0,371,53.13a43.69,43.69,0,0,0-1.38-10.92h10.15a53.79,53.79,0,0,1,1.11,10.92c0,29.3-23.53,53.13-52.67,53.13a53.59,53.59,0,0,1-7.43-.52v-10Z"
          />
          <path
            className="cls-2"
            d="M324.56,9.89a43,43,0,0,0-42.79,43.24,43.68,43.68,0,0,0,1.72,12.19H273.28a53.72,53.72,0,0,1-1.4-12.19C271.88,23.83,295.42,0,324.56,0"
          />
          <path
            className="cls-2"
            d="M331.39,35.48V84.73H320.76V26.25a48.23,48.23,0,0,1,6.25-.4c14.24,0,28.17,8.83,28.17,22.3S341.25,70.46,327,70.46s-28.17-8.84-28.17-22.31V41.83h9.29v6.32c0,6,7.13,13,18.88,13s18.88-7,18.88-13c0-5.25-5.38-11.2-14.5-12.67Z"
          />
          <path
            className="cls-2"
            d="M142.8,91a5.22,5.22,0,0,1,1.6,4.06,8.85,8.85,0,0,1-1.23,4.39,7.45,7.45,0,0,1-3,2.87,8.9,8.9,0,0,1-4.31,1.06h-5.22a.41.41,0,0,0-.46.41l-2,11.17a.43.43,0,0,1-.49.41h-1.94c-.22,0-.33-.1-.33-.31v-.13l4.4-25a.44.44,0,0,1,.5-.41h8A6.37,6.37,0,0,1,142.8,91Zm-1.18,4.8c0-.14,0-.28,0-.41a3.36,3.36,0,0,0-1-2.5,3.68,3.68,0,0,0-2.71-1h-5.23a.43.43,0,0,0-.49.42l-1.48,8.35v.12c0,.19.11.29.33.29h5.22a5,5,0,0,0,3.33-1.25,5.5,5.5,0,0,0,1.89-3.18l.09-.4Z"
          />
          <path
            className="cls-2"
            d="M158,106a.44.44,0,0,1-.49.42H146.82a.4.4,0,0,0-.45.41l-.41,2.22c0,.14-.06.27-.08.39a2.42,2.42,0,0,0,0,.39,3.49,3.49,0,0,0,1,2.59,3.54,3.54,0,0,0,2.64,1,4.62,4.62,0,0,0,3-1.15c.49-.41.87-.74,1.11-1s.44-.37.58-.37a.65.65,0,0,1,.21,0l1.57.87c.16.08.24.18.24.29,0,.27-.23.64-.7,1.11a11.66,11.66,0,0,1-2.14,1.56,6.47,6.47,0,0,1-1.83.72,9.9,9.9,0,0,1-2.4.27,6.38,6.38,0,0,1-4.46-1.44,5,5,0,0,1-1.59-3.92,10.1,10.1,0,0,1,.11-1.4l1-5.55a7.31,7.31,0,0,1,1-2.58,9,9,0,0,1,1.89-2.14,9.23,9.23,0,0,1,2.53-1.46,7.91,7.91,0,0,1,2.88-.54,6.44,6.44,0,0,1,2.48.46,6,6,0,0,1,1.94,1.21,5.4,5.4,0,0,1,1.23,1.79,5.68,5.68,0,0,1,.43,2.23c0,.16,0,.33,0,.49s-.05.35-.08.54Zm-2.24-2.92a2.73,2.73,0,0,0,0-.41,3.45,3.45,0,0,0-1-2.5,3.61,3.61,0,0,0-2.68-1,4.73,4.73,0,0,0-1.75.33,5.06,5.06,0,0,0-1.52.93,6.48,6.48,0,0,0-1.17,1.38,5.13,5.13,0,0,0-.7,1.74l-.13.57v.09c0,.22.13.33.37.33h7.94q.33,0,.45-.42l.13-.57A3.07,3.07,0,0,0,155.78,103.08Z"
          />
          <path
            className="cls-2"
            d="M171.78,99.7a.4.4,0,0,1-.45.41,4.46,4.46,0,0,1-.64-.06,5.8,5.8,0,0,0-.88-.06,5,5,0,0,0-1.81.33,5.25,5.25,0,0,0-2.72,2.3,5.2,5.2,0,0,0-.62,1.69L162.81,115a.43.43,0,0,1-.49.41h-2c-.22,0-.33-.1-.33-.31v-.13l3.05-17.34c0-.27.19-.41.49-.41h1.52c.22,0,.33.1.33.31v.12l-.37,2v.12c0,.22.1.33.29.33s.47-.21.93-.64a19.55,19.55,0,0,1,2-1.58,3.55,3.55,0,0,1,1-.51,3.07,3.07,0,0,1,1-.19h1.52c.22,0,.33.1.33.31v.12Z"
          />
          <path
            className="cls-2"
            d="M167.66,123.6c-1,0-1.56-.12-1.56-.37a.55.55,0,0,1,.08-.29l.82-1.54a.49.49,0,0,1,.46-.25l.2,0,.41.06a6.9,6.9,0,0,0,3.56-1.5,4.93,4.93,0,0,0,1.62-2.9l.5-2.92,2.38-13.45v-.13c0-.19-.11-.29-.33-.29h-1.11c-.24,0-.37-.1-.37-.32v-.09l.29-1.52a.43.43,0,0,1,.49-.41h1.11a.41.41,0,0,0,.46-.41l.45-2.51a8.91,8.91,0,0,1,3-5,7.49,7.49,0,0,1,5.14-2.09c1.32,0,2,.09,2,.26a.92.92,0,0,1-.12.32l-.78,1.53a.78.78,0,0,1-.45.29,3.53,3.53,0,0,1-.5,0,2.75,2.75,0,0,0-.41,0,4.12,4.12,0,0,0-1.68.35,5.34,5.34,0,0,0-1.48.92,5.51,5.51,0,0,0-1.13,1.39,5,5,0,0,0-.64,1.71l-.54,2.93v.08c0,.22.13.33.37.33h3c.21,0,.32.1.32.29v.12l-.28,1.52a.41.41,0,0,1-.46.41h-3a.43.43,0,0,0-.49.42l-2.39,13.46-.41,2.48a7.83,7.83,0,0,1-1,2.84,8.66,8.66,0,0,1-1.93,2.28,8.89,8.89,0,0,1-2.57,1.53,8,8,0,0,1-2.94.55"
          />
          <path
            className="cls-2"
            d="M197.82,109a7.8,7.8,0,0,1-2.8,4.9,8.49,8.49,0,0,1-5.59,1.86,6.38,6.38,0,0,1-4.46-1.44,5,5,0,0,1-1.59-3.92,10.1,10.1,0,0,1,.11-1.4l1-5.55a8,8,0,0,1,2.8-4.9,8.44,8.44,0,0,1,5.52-1.82,6.54,6.54,0,0,1,4.52,1.44,5,5,0,0,1,1.6,3.92,9.18,9.18,0,0,1-.1,1.36Zm-1.75-5.93a2.05,2.05,0,0,0,0-.37,3.45,3.45,0,0,0-1.07-2.59,3.87,3.87,0,0,0-2.8-1,4.56,4.56,0,0,0-1.72.35,5.33,5.33,0,0,0-1.52,1,5.22,5.22,0,0,0-1.13,1.38,5,5,0,0,0-.62,1.69l-1,5.55a3.74,3.74,0,0,0-.08.38,2.05,2.05,0,0,0,0,.37,3.57,3.57,0,0,0,1,2.61,3.51,3.51,0,0,0,2.63,1,4.91,4.91,0,0,0,1.82-.35,5.68,5.68,0,0,0,1.56-.95,5.33,5.33,0,0,0,1.18-1.4A5.2,5.2,0,0,0,195,109l1-5.55A3.48,3.48,0,0,0,196.07,103.11Z"
          />
          <path
            className="cls-2"
            d="M212.6,99.7a.41.41,0,0,1-.46.41,4.34,4.34,0,0,1-.63-.06,6,6,0,0,0-.89-.06,5,5,0,0,0-1.81.33,5.27,5.27,0,0,0-1.57.92,5.42,5.42,0,0,0-1.15,1.38,5,5,0,0,0-.61,1.69L203.62,115c0,.27-.19.41-.49.41h-2c-.22,0-.33-.1-.33-.31v-.13l3.05-17.34a.43.43,0,0,1,.49-.41h1.53c.22,0,.33.1.33.31v.12l-.37,2v.12c0,.22.09.33.28.33s.48-.21.93-.64a18.82,18.82,0,0,1,2-1.58,3.43,3.43,0,0,1,1-.51,3,3,0,0,1,1-.19h1.53c.22,0,.33.1.33.31v.12Z"
          />
          <path
            className="cls-2"
            d="M237.77,115a.44.44,0,0,1-.5.41h-2c-.22,0-.33-.1-.33-.31v-.13l1.93-11a3.11,3.11,0,0,0,.08-.37,1.73,1.73,0,0,0,0-.32,3.78,3.78,0,0,0-.27-1.42,3.84,3.84,0,0,0-.72-1.17,3.35,3.35,0,0,0-1.05-.78,2.73,2.73,0,0,0-1.25-.29,3.54,3.54,0,0,0-1.46.35,5.65,5.65,0,0,0-1.42.94,6.7,6.7,0,0,0-1.15,1.38,4.73,4.73,0,0,0-.66,1.69L227.1,115a.44.44,0,0,1-.5.41h-2c-.22,0-.33-.1-.33-.31v-.13l1.93-11c0-.13.05-.26.07-.37s0-.23,0-.37a3.68,3.68,0,0,0-1-2.54A3,3,0,0,0,223,99.54a3.5,3.5,0,0,0-1.46.35,5.94,5.94,0,0,0-1.44.94,5.87,5.87,0,0,0-1.15,1.38,4.89,4.89,0,0,0-.64,1.69L216.41,115a.44.44,0,0,1-.5.41h-2c-.22,0-.33-.1-.33-.31v-.13l3-17.34a.43.43,0,0,1,.5-.41h1.52c.22,0,.33.1.33.31v.12l-.29,1.64v.12c0,.24.08.36.25.36a1.35,1.35,0,0,0,.72-.43,14.1,14.1,0,0,1,1.33-1,5.31,5.31,0,0,1,1.58-.82,5.11,5.11,0,0,1,1.55-.25,4.82,4.82,0,0,1,4,2.43c.1.13.2.2.28.2a1,1,0,0,0,.37-.2l1.07-.85A10.53,10.53,0,0,1,231,98a6.64,6.64,0,0,1,1.38-.57,6.33,6.33,0,0,1,1.79-.23,5.72,5.72,0,0,1,4.14,1.48,5.14,5.14,0,0,1,1.55,3.91,7.89,7.89,0,0,1-.12,1.32Z"
          />
          <path
            className="cls-2"
            d="M255.61,115a.44.44,0,0,1-.5.41h-1.52c-.22,0-.33-.1-.33-.31v-.13l.29-1.77v-.12c0-.22-.1-.33-.29-.33s-.4.17-.78.5-.93.77-1.64,1.33a4.69,4.69,0,0,1-2.92.83,5.65,5.65,0,0,1-4.07-1.48,5.17,5.17,0,0,1-1.57-4,6.56,6.56,0,0,1,.13-1.32l.82-4.73a7.47,7.47,0,0,1,1-2.7A9,9,0,0,1,246,99.08a8.21,8.21,0,0,1,2.39-1.4,8,8,0,0,1,2.75-.49,3.58,3.58,0,0,1,2.18.5,6.79,6.79,0,0,1,1.46,1.4c.34.47.63.71.85.71s.31-.16.37-.46l.29-1.74c0-.27.19-.41.49-.41h1.52c.22,0,.33.1.33.31v.13Zm-.82-11.44c0-.11,0-.23,0-.37a3.42,3.42,0,0,0-1.07-2.58,3.83,3.83,0,0,0-2.79-1,4.47,4.47,0,0,0-1.71.35,5.42,5.42,0,0,0-2.65,2.32,5.23,5.23,0,0,0-.62,1.68l-.82,4.72a3.11,3.11,0,0,0-.08.37,2.05,2.05,0,0,0,0,.37,3.51,3.51,0,0,0,1.06,2.6,3.8,3.8,0,0,0,2.79,1.05,4.47,4.47,0,0,0,1.71-.35,5.15,5.15,0,0,0,1.52-1,6.12,6.12,0,0,0,1.15-1.42,5.29,5.29,0,0,0,.64-1.66l.82-4.72A3.12,3.12,0,0,0,254.79,103.53Z"
          />
          <path
            className="cls-2"
            d="M275,115a.43.43,0,0,1-.49.41h-2c-.22,0-.33-.1-.33-.31v-.13l1.94-11a3,3,0,0,0,.07-.37,2,2,0,0,0,0-.37,3.46,3.46,0,0,0-1.07-2.58,3.87,3.87,0,0,0-2.8-1,4.46,4.46,0,0,0-1.7.35,5.53,5.53,0,0,0-1.52.94,5.34,5.34,0,0,0-1.13,1.38,5,5,0,0,0-.62,1.68l-1.93,11a.44.44,0,0,1-.5.41h-2c-.22,0-.33-.1-.33-.31v-.13l3-17.34a.43.43,0,0,1,.5-.41h1.52c.22,0,.33.1.33.31v.13l-.29,1.66v.12c0,.22.1.33.29.33s.36-.14.67-.44.78-.66,1.38-1.1a5.27,5.27,0,0,1,3.21-1,5.8,5.8,0,0,1,4.16,1.48,5.18,5.18,0,0,1,1.58,4,7.71,7.71,0,0,1-.13,1.28Z"
          />
          <path
            className="cls-2"
            d="M284.25,98.61a8.31,8.31,0,0,1,5.5-1.84,8.82,8.82,0,0,1,2.39.31,6.59,6.59,0,0,1,1.81.81A3.88,3.88,0,0,1,295.1,99a2.32,2.32,0,0,1,.41,1.25c0,.14-.11.26-.33.37l-1.89.86a.37.37,0,0,1-.16,0,.36.36,0,0,1-.29-.17l-.72-.86a4.9,4.9,0,0,0-.72-.72,3.18,3.18,0,0,0-.86-.5,3.53,3.53,0,0,0-1.2-.18,4.86,4.86,0,0,0-1.81.35,5.86,5.86,0,0,0-1.56.93,4.75,4.75,0,0,0-1.15,1.37,5.54,5.54,0,0,0-.62,1.72l-1,5.55a2,2,0,0,0-.08.4,2.38,2.38,0,0,0,0,.39,3.49,3.49,0,0,0,3.66,3.62,4.57,4.57,0,0,0,3-1.15,13.44,13.44,0,0,0,1.11-1c.25-.24.44-.37.58-.37a.54.54,0,0,1,.2,0l1.57.87c.16.08.24.18.24.29,0,.27-.23.64-.7,1.11a11.52,11.52,0,0,1-2.13,1.56,6.66,6.66,0,0,1-1.84.72,9.9,9.9,0,0,1-2.4.27,6.35,6.35,0,0,1-4.45-1.44,5.08,5.08,0,0,1-1.56-3.92,8.83,8.83,0,0,1,.12-1.4l1-5.55A8,8,0,0,1,284.25,98.61Z"
          />
          <path
            className="cls-2"
            d="M311.6,106a.43.43,0,0,1-.5.42H300.4a.4.4,0,0,0-.45.41l-.41,2.22c0,.14-.06.27-.08.39a2.38,2.38,0,0,0,0,.39,3.5,3.5,0,0,0,1,2.59,3.56,3.56,0,0,0,2.64,1,4.62,4.62,0,0,0,3-1.15,13.44,13.44,0,0,0,1.11-1c.25-.24.44-.37.58-.37a.65.65,0,0,1,.21,0l1.57.87c.16.08.24.18.24.29a1.94,1.94,0,0,1-.69,1.11,12.41,12.41,0,0,1-2.14,1.56,6.72,6.72,0,0,1-1.83.72,10,10,0,0,1-2.41.27,6.38,6.38,0,0,1-4.46-1.44,5,5,0,0,1-1.59-3.92,10.1,10.1,0,0,1,.11-1.4l1-5.55a7.11,7.11,0,0,1,1-2.58,9,9,0,0,1,1.89-2.14,9.23,9.23,0,0,1,2.53-1.46,7.91,7.91,0,0,1,2.88-.54,6.53,6.53,0,0,1,2.49.46,6,6,0,0,1,1.93,1.21,5.4,5.4,0,0,1,1.23,1.79,5.68,5.68,0,0,1,.43,2.23c0,.16,0,.33,0,.49s-.05.35-.08.54Zm-2.24-2.92a2.73,2.73,0,0,0,0-.41,3.45,3.45,0,0,0-1-2.5,3.61,3.61,0,0,0-2.68-1,4.77,4.77,0,0,0-1.75.33,5.06,5.06,0,0,0-1.52.93,6.21,6.21,0,0,0-1.17,1.38,5.34,5.34,0,0,0-.7,1.74l-.13.57v.09c0,.22.13.33.38.33h7.93q.33,0,.45-.42l.13-.57A3.07,3.07,0,0,0,309.36,103.08Z"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "capvers"
    ) {
      return (
        <svg
          id="capvers"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 701.13 209.38"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <g className="cls-2">
            <path
              className="cls-3"
              d="M151.68,0S80.78,10.91,3.75,69.53l1.36,31.7S28,82.14,49.08,74C49.08,74,15,104,0,129.52l7.84,24.55s6.48-8.87,30-24.21c0,0-14.37,17.95-14.72,21l1.72,3.1,3.09-1s-7.56,13.4-8.25,15.8l2.75,3.78,1.72-.34-.68,4.12,2.75,3.09s13.74-24,24-29.54l2.4,3.77S38.92,173.23,37.2,177c0,0,4.47,11,6.18,12.36,0,0,96.55-101.35,156-112L184.6,53.32s-55,7.22-68.72,14.44c0,0,33.67-19.93,44.67-22.68l-3.44-15.81S88.74,49.2,83.24,53.67c0,0,33.67-25.08,66.66-36.76"
            />
            <path
              className="cls-4"
              d="M309.42,113.91v1.67c0,6.22-.08,11.84-5.07,16.17s-11.11,4.18-17.5,4.18c-15,0-25.94-.76-25.94-21.56V99.64c0-18.83,9.77-21.56,25.94-21.56,15.15,0,22.2,1.59,22.49,18.68V99H294.2v-2.2c-.51-5.09-4-5.47-9-5.47-8.38,0-9.19,2.66-9.19,10.78V111c0,8.5.36,11.77,9.19,11.77,6.09,0,9-.46,9-7.14v-1.67"
            />
          </g>
          <path
            className="cls-4"
            d="M334.48,125.67l-2.71,9.8H316.48L333,78.54h22.34l16.76,56.93h-15l-2.87-9.8m-9.77-35.75h-.15l-6.69,24.67h13.67Z"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M386.07,135.47V78.54h27.7c13.67,0,18.82,6,18.82,20.87,0,16-3.45,21.49-18.82,21.49h-13v14.57m10.07-27.78c5.8-.23,6.61-.92,6.61-8.28,0-5.84-.88-7.67-6.61-7.67H400.77v16Z"
            />
          </g>
          <polyline
            className="cls-4"
            points="509.31 78.54 524.52 78.54 508.42 135.47 485.5 135.47 469.92 78.54 484.83 78.54 496.74 122.41 497.18 122.41"
          />
          <polyline
            className="cls-4"
            points="552.86 101.39 576.38 101.39 576.38 111.94 552.86 111.94 552.86 123.02 578.44 123.02 578.44 135.47 538.16 135.47 538.16 78.54 577.93 78.54 577.93 90.99 552.86 90.99"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M592.53,78.54H620.9c12.72.23,19,3,19,17.23,0,9.49,0,15-10.44,17.54v.6c6,.23,9.92,3.64,9.92,10.1v11.46h-14.7v-8c.15-4.25-1.61-7.13-6-7.13H607.23v15.1h-14.7m26.09-28.31c6.32,0,6.1-2.44,6.1-8.89,0-5.09-1.24-6.52-6.1-6.52H607.23v15.41Z"
            />
            <path
              className="cls-4"
              d="M680.77,100.86c16.32,1.21,20.36,3.34,20.36,16.39,0,9.42.37,18.68-23.88,18.68-14,0-23.37-.31-23.37-19H668c0,5.92,2,6.53,9.26,6.53,6.91,0,9.18-.46,9.18-5.24s-.8-4.86-7.71-5.32l-3.24-.22c-13.6-1-21.53-.92-21.53-17.24s8.89-17.38,23.3-17.38c12,0,22.34.23,22.34,15.94v2.35H685.48c0-5.84-2.36-5.84-8.23-5.84-7.94,0-8.6,1.67-8.6,4.86,0,4.56,2.13,4.71,6,5"
            />
          </g>
          <polygon
            className="cls-4"
            points="260.45 164.59 270.53 164.59 270.53 166.62 262.89 166.62 262.89 172.84 269.94 172.84 269.94 174.83 262.89 174.83 262.89 183.3 260.45 183.3 260.45 164.59"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M288.07,176.47c0,5-3.47,7.14-6.69,7.14-3.61,0-6.44-2.67-6.44-6.91,0-4.48,3-7.11,6.66-7.11,3.86,0,6.47,2.8,6.47,6.88m-10.63.14c0,2.94,1.66,5.16,4.06,5.16s4.07-2.19,4.07-5.21c0-2.28-1.13-5.14-4-5.14s-4.11,2.66-4.11,5.19"
            />
            <path
              className="cls-4"
              d="M294,174.06c0-1.59,0-2.95-.11-4.19H296l.11,2.66h.08a4.07,4.07,0,0,1,3.75-2.94l.67,0V172l-.83-.06a3.41,3.41,0,0,0-3.28,3.11,6.8,6.8,0,0,0-.08,1.14v7.16H294Z"
            />
            <path
              className="cls-4"
              d="M306.06,173.5c0-1.42-.05-2.52-.11-3.63h2.14l.11,2.19h.08a4.64,4.64,0,0,1,4.25-2.47,4,4,0,0,1,3.77,2.69h.06a5.31,5.31,0,0,1,1.53-1.75,4.49,4.49,0,0,1,2.94-.94c1.8,0,4.44,1.16,4.44,5.83v7.88h-2.38v-7.58c0-2.61-1-4.13-2.92-4.13a3.21,3.21,0,0,0-2.92,2.19,4.16,4.16,0,0,0-.19,1.22v8.3h-2.39v-8.05c0-2.14-.94-3.66-2.8-3.66a3.37,3.37,0,0,0-3,2.44,3.46,3.46,0,0,0-.19,1.19v8.08h-2.39Z"
            />
            <path
              className="cls-4"
              d="M341.51,180.08a22.22,22.22,0,0,0,.2,3.22h-2.19l-.2-1.69h-.08a5,5,0,0,1-4.11,2,3.83,3.83,0,0,1-4.11-3.86c0-3.25,2.89-5,8.08-5v-.28a2.75,2.75,0,0,0-3.06-3.08,6.45,6.45,0,0,0-3.52,1l-.56-1.64a8.74,8.74,0,0,1,4.44-1.16c4.12,0,5.11,2.8,5.11,5.47Zm-2.35-3.63c-2.67-.06-5.7.41-5.7,3a2.14,2.14,0,0,0,2.28,2.33,3.38,3.38,0,0,0,3.3-2.25l.12-.77Z"
            />
            <path
              className="cls-4"
              d="M351.15,166.64v3.22h3.49v1.87h-3.49V179c0,1.66.47,2.61,1.83,2.61a4.58,4.58,0,0,0,1.42-.17l.1,1.86a6.42,6.42,0,0,1-2.16.34,3.49,3.49,0,0,1-2.64-1,5.3,5.3,0,0,1-.94-3.53v-7.32h-2.08v-1.87h2.08v-2.49Z"
            />
            <path
              className="cls-4"
              d="M363,166.09a1.46,1.46,0,0,1-1.55,1.5,1.44,1.44,0,0,1-1.47-1.5,1.49,1.49,0,0,1,1.52-1.53,1.47,1.47,0,0,1,1.5,1.53m-2.72,3.77h2.45V183.3h-2.45Z"
            />
            <path
              className="cls-4"
              d="M381.77,176.47c0,5-3.47,7.14-6.69,7.14-3.61,0-6.44-2.67-6.44-6.91,0-4.48,3-7.11,6.66-7.11,3.86,0,6.47,2.8,6.47,6.88m-10.63.14c0,2.94,1.66,5.16,4.05,5.16s4.08-2.19,4.08-5.21c0-2.28-1.14-5.14-4-5.14s-4.1,2.66-4.1,5.19"
            />
            <path
              className="cls-4"
              d="M387.71,173.5c0-1.42,0-2.52-.11-3.63h2.16l.14,2.21H390a5,5,0,0,1,4.44-2.49c1.86,0,4.75,1.11,4.75,5.72v8H396.7v-7.74c0-2.17-.8-4-3.1-4a3.52,3.52,0,0,0-3.28,2.49,3.6,3.6,0,0,0-.17,1.14v8.08h-2.44Z"
            />
            <path
              className="cls-4"
              d="M405.64,180.83a7,7,0,0,0,3.25.94c1.75,0,2.58-.86,2.58-2s-.69-1.77-2.47-2.44c-2.44-.89-3.58-2.19-3.58-3.8,0-2.17,1.78-3.94,4.64-3.94a6.23,6.23,0,0,1,3.27.83l-.58,1.78a5.15,5.15,0,0,0-2.75-.81c-1.44,0-2.22.84-2.22,1.83s.78,1.61,2.53,2.31c2.3.86,3.52,2,3.52,4,0,2.39-1.86,4-5,4a7.59,7.59,0,0,1-3.78-.94Z"
            />
          </g>
          <polygon
            className="cls-4"
            points="431.07 166.64 425.38 166.64 425.38 164.59 439.23 164.59 439.23 166.64 433.51 166.64 433.51 183.3 431.07 183.3 431.07 166.64"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M454.28,176.47c0,5-3.47,7.14-6.69,7.14-3.61,0-6.44-2.67-6.44-6.91,0-4.48,3-7.11,6.66-7.11,3.86,0,6.47,2.8,6.47,6.88m-10.63.14c0,2.94,1.66,5.16,4.05,5.16s4.08-2.19,4.08-5.21c0-2.28-1.13-5.14-4-5.14s-4.11,2.66-4.11,5.19"
            />
            <path
              className="cls-4"
              d="M471.46,179.61c0,1.42,0,2.64.12,3.69h-2.17l-.14-2.19h0a5,5,0,0,1-4.45,2.5c-2.1,0-4.63-1.2-4.63-5.89v-7.86h2.44v7.42c0,2.55.8,4.3,3,4.3a3.52,3.52,0,0,0,3.22-2.25,3.33,3.33,0,0,0,.22-1.25v-8.22h2.44Z"
            />
            <path
              className="cls-4"
              d="M478.38,174.06c0-1.59,0-2.95-.11-4.19h2.14l.1,2.66h.09a4.06,4.06,0,0,1,3.74-2.94l.67,0V172l-.83-.06A3.41,3.41,0,0,0,480.9,175a8,8,0,0,0-.08,1.14v7.16h-2.44Z"
            />
            <path
              className="cls-4"
              d="M493.15,166.09a1.47,1.47,0,0,1-1.56,1.5,1.44,1.44,0,0,1-1.47-1.5,1.49,1.49,0,0,1,1.53-1.53,1.47,1.47,0,0,1,1.5,1.53m-2.73,3.77h2.45V183.3h-2.45Z"
            />
            <path
              className="cls-4"
              d="M499.45,180.83a7,7,0,0,0,3.25.94c1.74,0,2.58-.86,2.58-2s-.69-1.77-2.47-2.44c-2.44-.89-3.58-2.19-3.58-3.8,0-2.17,1.77-3.94,4.63-3.94a6.27,6.27,0,0,1,3.28.83l-.59,1.78a5.11,5.11,0,0,0-2.74-.81c-1.45,0-2.22.84-2.22,1.83s.77,1.61,2.52,2.31c2.31.86,3.53,2,3.53,4,0,2.39-1.87,4-5,4a7.58,7.58,0,0,1-3.77-.94Z"
            />
            <path
              className="cls-4"
              d="M513.63,173.5c0-1.42,0-2.52-.11-3.63h2.14l.11,2.19h.09a4.63,4.63,0,0,1,4.24-2.47,4,4,0,0,1,3.78,2.69h0a5.31,5.31,0,0,1,1.53-1.75,4.5,4.5,0,0,1,2.94-.94c1.81,0,4.44,1.16,4.44,5.83v7.88h-2.38v-7.58c0-2.61-1-4.13-2.92-4.13a3.2,3.2,0,0,0-2.91,2.19,3.86,3.86,0,0,0-.19,1.22v8.3h-2.39v-8.05c0-2.14-.95-3.66-2.81-3.66a3.36,3.36,0,0,0-3,2.44,3.23,3.23,0,0,0-.2,1.19v8.08h-2.39Z"
            />
            <path
              className="cls-4"
              d="M541,177c0,3.3,2.13,4.66,4.6,4.66a8.78,8.78,0,0,0,3.73-.69l.44,1.75a11,11,0,0,1-4.5.85c-4.13,0-6.61-2.74-6.61-6.79s2.39-7.22,6.31-7.22c4.41,0,5.55,3.83,5.55,6.3a5.55,5.55,0,0,1-.09,1.14Zm7.16-1.75c0-1.53-.64-3.94-3.39-3.94-2.49,0-3.55,2.24-3.75,3.94Z"
            />
          </g>
          <polygon
            className="cls-4"
            points="567.66 164.59 567.66 172.42 576.71 172.42 576.71 164.59 579.15 164.59 579.15 183.3 576.71 183.3 576.71 174.53 567.66 174.53 567.66 183.3 565.22 183.3 565.22 164.59 567.66 164.59"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M598.28,176.47c0,5-3.47,7.14-6.69,7.14-3.61,0-6.44-2.67-6.44-6.91,0-4.48,3-7.11,6.66-7.11,3.86,0,6.47,2.8,6.47,6.88m-10.63.14c0,2.94,1.66,5.16,4.05,5.16s4.08-2.19,4.08-5.21c0-2.28-1.14-5.14-4-5.14s-4.11,2.66-4.11,5.19m4.88-12.55,2.67,4h-1.86l-1.64-2.61h-.06L590.06,168h-1.83l2.61-4Z"
            />
            <path
              className="cls-4"
              d="M607.16,166.64v3.22h3.5v1.87h-3.5V179c0,1.66.48,2.61,1.84,2.61a4.56,4.56,0,0,0,1.41-.17l.11,1.86a6.51,6.51,0,0,1-2.16.34,3.48,3.48,0,0,1-2.64-1,5.25,5.25,0,0,1-.94-3.53v-7.32h-2.09v-1.87h2.09v-2.49Z"
            />
            <path
              className="cls-4"
              d="M617.46,177c.06,3.3,2.14,4.66,4.61,4.66a8.73,8.73,0,0,0,3.72-.69l.45,1.75a11,11,0,0,1-4.5.85c-4.14,0-6.61-2.74-6.61-6.79s2.39-7.22,6.3-7.22c4.42,0,5.55,3.83,5.55,6.3a5.68,5.68,0,0,1-.08,1.14Zm7.17-1.75c0-1.53-.64-3.94-3.39-3.94-2.5,0-3.55,2.24-3.75,3.94Z"
            />
          </g>
          <rect
            className="cls-4"
            x="632.87"
            y="163.59"
            width="2.44"
            height="19.71"
          />
          <rect
            className="cls-4"
            x="642.28"
            y="163.59"
            width="2.44"
            height="19.71"
          />
          <g className="cls-2">
            <path
              className="cls-4"
              d="M653.05,177c.06,3.3,2.14,4.66,4.61,4.66a8.73,8.73,0,0,0,3.72-.69l.45,1.75a11,11,0,0,1-4.5.85c-4.14,0-6.61-2.74-6.61-6.79s2.39-7.22,6.3-7.22c4.42,0,5.55,3.83,5.55,6.3a5.68,5.68,0,0,1-.08,1.14Zm7.17-1.75c0-1.53-.65-3.94-3.39-3.94-2.5,0-3.56,2.24-3.75,3.94Z"
            />
            <path
              className="cls-4"
              d="M668.46,174.06c0-1.59,0-2.95-.11-4.19h2.14l.11,2.66h.08a4.07,4.07,0,0,1,3.75-2.94l.67,0V172l-.84-.06A3.4,3.4,0,0,0,671,175a6.76,6.76,0,0,0-.09,1.14v7.16h-2.44Z"
            />
            <path
              className="cls-4"
              d="M683.23,166.09a1.46,1.46,0,0,1-1.56,1.5,1.44,1.44,0,0,1-1.47-1.5,1.5,1.5,0,0,1,1.53-1.53,1.47,1.47,0,0,1,1.5,1.53m-2.72,3.77H683V183.3h-2.44Z"
            />
            <path
              className="cls-4"
              d="M691.23,177c0,3.3,2.13,4.66,4.6,4.66a8.73,8.73,0,0,0,3.72-.69l.45,1.75a11,11,0,0,1-4.5.85c-4.14,0-6.61-2.74-6.61-6.79s2.39-7.22,6.3-7.22c4.42,0,5.55,3.83,5.55,6.3a5.68,5.68,0,0,1-.08,1.14Zm7.16-1.75c0-1.53-.64-3.94-3.39-3.94-2.5,0-3.55,2.24-3.75,3.94Z"
            />
          </g>
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "isifa"
    ) {
      return (
        <svg
          id="isifa"
          data-name="Calque 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 155.04 154.91"
          className="icon icon-pigier-white"
        >
          <path
            className="cls-1"
            d="M155,105.79a49.12,49.12,0,0,1-49.12,49.12H0V49.12A49.12,49.12,0,0,1,49.12,0H155Z"
            fill="#e20e17"
          />
          <path className="cls-2" d="M22.49,57.59V30h5.78V57.59Z" fill="#ffffff" />
          <path
            className="cls-2"
            d="M42.71,43.32a2.89,2.89,0,0,0-1.08-2.1,4.93,4.93,0,0,0-2.75-.61,5.75,5.75,0,0,0-2.37.4,1.35,1.35,0,0,0-.83,1.31,1.51,1.51,0,0,0,.83,1.39,11,11,0,0,0,2.5.94c1.16.33,2.27.63,3.33.89a25.12,25.12,0,0,1,2.78.86,5.78,5.78,0,0,1,2.5,1.81,5.07,5.07,0,0,1,.88,3.14,6,6,0,0,1-2.27,5c-1.52,1.19-3.74,1.79-6.68,1.79-3.16,0-5.58-.66-7.26-2A6.45,6.45,0,0,1,29.69,51h5.57a2.57,2.57,0,0,0,1.13,2.24,5.33,5.33,0,0,0,3.12.79,6.43,6.43,0,0,0,2.54-.47,1.68,1.68,0,0,0,1.08-1.65,1.59,1.59,0,0,0-1-1.54,12.93,12.93,0,0,0-2.31-.79c-1.72-.41-3.11-.79-4.16-1.12A10.79,10.79,0,0,1,33,47.27a5.18,5.18,0,0,1-2-2.08,5.69,5.69,0,0,1-.56-2.54,6.42,6.42,0,0,1,.45-2.41,4.82,4.82,0,0,1,1.5-1.94A7.64,7.64,0,0,1,35.08,37a14.73,14.73,0,0,1,4-.46q4.46,0,6.55,1.7a6.7,6.7,0,0,1,2.31,5Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M50.16,34.66v-5h5.41v5Zm0,22.93V37.12h5.41V57.59Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M60.14,57.59V41h-3V37.12h3q0-7.48,8.7-7.49V34a8.43,8.43,0,0,0-1.68.14,2,2,0,0,0-1,.52,2,2,0,0,0-.52,1,6.25,6.25,0,0,0-.15,1.48H69V41h-3.5V57.59Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M22.46,91.44V63.77H34.67a9.26,9.26,0,0,1,3.66.69,8.18,8.18,0,0,1,2.79,1.92,8.44,8.44,0,0,1,1.79,2.85,9.62,9.62,0,0,1,.63,3.5,9.44,9.44,0,0,1-.63,3.48A7.58,7.58,0,0,1,41.12,79a8.31,8.31,0,0,1-2.79,1.79,9.82,9.82,0,0,1-3.66.65H28.25v10ZM33.75,76.69a4.79,4.79,0,0,0,3.6-1.15,4.09,4.09,0,0,0,1.11-3,3.92,3.92,0,0,0-1.11-2.87,4.87,4.87,0,0,0-3.6-1.12h-5.5v8.12Z"
            fill="#ffffff"
          />
          <path className="cls-2" d="M44.83,91.44v-28h5.42v28Z" fill="#ffffff" />
          <path
            className="cls-2"
            d="M65.87,91.44V88.56A7,7,0,0,1,59.49,92a7.15,7.15,0,0,1-2.81-.54,6.25,6.25,0,0,1-2.18-1.55,7.07,7.07,0,0,1-1.44-2.37,8.58,8.58,0,0,1-.52-3.08V70.94H58V83.6c0,2.56,1.16,3.84,3.46,3.84a3.81,3.81,0,0,0,3.15-1.32,5.19,5.19,0,0,0,1.06-3.35V70.94H71v20.5Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M85.7,77.15A2.93,2.93,0,0,0,84.62,75a5,5,0,0,0-2.75-.6,5.61,5.61,0,0,0-2.38.4,1.35,1.35,0,0,0-.83,1.31,1.52,1.52,0,0,0,.83,1.39,11,11,0,0,0,2.5.94q1.76.49,3.33.9a23.64,23.64,0,0,1,2.8.85A5.8,5.8,0,0,1,90.61,82a5,5,0,0,1,.88,3.15,6,6,0,0,1-2.27,5C87.7,91.38,85.48,92,82.53,92c-3.16,0-5.59-.67-7.27-2a6.47,6.47,0,0,1-2.6-5.13h5.58a2.57,2.57,0,0,0,1.13,2.25,5.33,5.33,0,0,0,3.12.8A6.22,6.22,0,0,0,85,87.42a1.69,1.69,0,0,0,1.09-1.65,1.58,1.58,0,0,0-1-1.54,12.55,12.55,0,0,0-2.32-.79c-1.72-.42-3.11-.79-4.16-1.13A10.35,10.35,0,0,1,76,81.1,5.25,5.25,0,0,1,74,79a5.83,5.83,0,0,1-.56-2.54,6.28,6.28,0,0,1,.46-2.42,4.56,4.56,0,0,1,1.5-1.93,7.59,7.59,0,0,1,2.68-1.27,14.86,14.86,0,0,1,4-.46q4.45,0,6.56,1.71a6.67,6.67,0,0,1,2.32,5Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M32.05,124.74,22.69,97.1h6.16l6,19.4,6-19.4h6l-9.36,27.64Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M57.49,124.74a8.18,8.18,0,0,1-.34-1.83,6.58,6.58,0,0,1-2.54,1.73,9.6,9.6,0,0,1-3.66.65q-3.54,0-5.18-1.57a5.32,5.32,0,0,1-1.65-4,7.45,7.45,0,0,1,.71-3.52,5.25,5.25,0,0,1,2-2.06,9.47,9.47,0,0,1,3-1.11c1.16-.23,2.41-.45,3.77-.64a7.17,7.17,0,0,0,2.75-.77,1.9,1.9,0,0,0-.23-3.12,4.8,4.8,0,0,0-2.52-.56,3.6,3.6,0,0,0-2.68.83,3.9,3.9,0,0,0-1,2.2h-5a9.34,9.34,0,0,1,.52-2.91,5.57,5.57,0,0,1,1.54-2.29,7.23,7.23,0,0,1,2.77-1.48,14.65,14.65,0,0,1,4.16-.52,13.54,13.54,0,0,1,4.1.54,6.57,6.57,0,0,1,2.71,1.56,6.08,6.08,0,0,1,1.48,2.54,12.15,12.15,0,0,1,.45,3.44v12.94Zm-.38-10a3,3,0,0,1-1.21.67,22.29,22.29,0,0,1-2.29.54,7.84,7.84,0,0,0-3.2,1.16,2.5,2.5,0,0,0-.87,2c0,1.53.87,2.29,2.62,2.29a5.09,5.09,0,0,0,1.93-.35,4.75,4.75,0,0,0,2.58-2.37,3.82,3.82,0,0,0,.4-1.73Z"
            fill="#ffffff"
          />
          <path className="cls-2" d="M64.9,124.74v-28h5.41v28Z" fill="#ffffff" />
          <path
            className="cls-2"
            d="M85.92,124.74v-2.87a7,7,0,0,1-6.37,3.42,7.11,7.11,0,0,1-2.81-.55,6.17,6.17,0,0,1-2.19-1.54,7.05,7.05,0,0,1-1.43-2.37,8.54,8.54,0,0,1-.52-3.08V104.26H78v12.66q0,3.83,3.45,3.83a3.83,3.83,0,0,0,3.15-1.31,5.15,5.15,0,0,0,1.06-3.35V104.26H91v20.48Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M98.36,115.92a5.86,5.86,0,0,0,1.36,3.7,4.1,4.1,0,0,0,3.22,1.38,4.49,4.49,0,0,0,2.36-.61,2.74,2.74,0,0,0,1.31-1.68h5.58a9,9,0,0,1-3.33,4.87,9.45,9.45,0,0,1-5.67,1.71Q93,125.29,93,114.13a13.13,13.13,0,0,1,.67-4.29,9.25,9.25,0,0,1,1.94-3.29,8.44,8.44,0,0,1,3.1-2.1,11.41,11.41,0,0,1,4.2-.73c3.16,0,5.56,1,7.18,3s2.44,5.08,2.44,9.16Zm8.54-3.41a5.66,5.66,0,0,0-.4-2,4.08,4.08,0,0,0-.93-1.42,3.81,3.81,0,0,0-1.34-.83,4.46,4.46,0,0,0-1.54-.27,3.87,3.87,0,0,0-2.81,1.19,5.05,5.05,0,0,0-1.35,3.31Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M126.67,110.47a2.93,2.93,0,0,0-1.08-2.11,4.94,4.94,0,0,0-2.75-.6,5.56,5.56,0,0,0-2.37.4,1.34,1.34,0,0,0-.83,1.31,1.51,1.51,0,0,0,.83,1.39,11.31,11.31,0,0,0,2.5.94c1.16.33,2.27.63,3.33.89a26,26,0,0,1,2.79.86,5.72,5.72,0,0,1,2.49,1.81,5,5,0,0,1,.88,3.14,6,6,0,0,1-2.27,5q-2.26,1.78-6.68,1.79-4.76,0-7.27-2a6.52,6.52,0,0,1-2.6-5.12h5.58a2.58,2.58,0,0,0,1.12,2.24,5.35,5.35,0,0,0,3.13.8,6.26,6.26,0,0,0,2.54-.48,1.68,1.68,0,0,0,1.08-1.65,1.59,1.59,0,0,0-1-1.54,12.93,12.93,0,0,0-2.31-.79c-1.72-.41-3.11-.79-4.16-1.12a11.07,11.07,0,0,1-2.67-1.21,5.25,5.25,0,0,1-2-2.08,5.83,5.83,0,0,1-.56-2.54,6.23,6.23,0,0,1,.46-2.41,4.59,4.59,0,0,1,1.5-1.94,7.77,7.77,0,0,1,2.68-1.27,15.22,15.22,0,0,1,4-.46c3,0,5.15.57,6.56,1.71a6.7,6.7,0,0,1,2.31,5Z"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M113,104.34a8,8,0,0,0-8-8,8,8,0,0,0,8-8,8,8,0,0,0,8,8,8,8,0,0,0-8,8"
            fill="#ffffff"
          />
          <path
            className="cls-2"
            d="M83.58,57.63a9.08,9.08,0,0,1-.33-1.83,6.75,6.75,0,0,1-2.54,1.72,9.64,9.64,0,0,1-3.66.65q-3.54,0-5.19-1.56a5.37,5.37,0,0,1-1.64-4.06A7.45,7.45,0,0,1,70.93,49,5.3,5.3,0,0,1,72.88,47a9.37,9.37,0,0,1,3-1.1c1.15-.24,2.41-.45,3.77-.65a7.23,7.23,0,0,0,2.75-.77,1.91,1.91,0,0,0-.23-3.12,4.85,4.85,0,0,0-2.52-.56,3.67,3.67,0,0,0-2.69.83,3.93,3.93,0,0,0-1,2.21h-5a9.07,9.07,0,0,1,.52-2.92A5.57,5.57,0,0,1,73,38.6a7.33,7.33,0,0,1,2.76-1.48,14.72,14.72,0,0,1,4.17-.52,13.56,13.56,0,0,1,4.1.55,6.59,6.59,0,0,1,2.7,1.56,5.86,5.86,0,0,1,1.48,2.54,11.67,11.67,0,0,1,.46,3.43v13Zm-.37-10a3,3,0,0,1-1.21.67,20.44,20.44,0,0,1-2.29.54A7.82,7.82,0,0,0,76.51,50a2.45,2.45,0,0,0-.88,2c0,1.52.88,2.29,2.62,2.29a5.15,5.15,0,0,0,1.94-.36A4.71,4.71,0,0,0,81.73,53a4.87,4.87,0,0,0,1-1.42,4,4,0,0,0,.4-1.73Z"
            fill="#ffffff"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "tunon"
    ) {
      return (
        <svg
          id="tunon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 153.49 32.23"
          className="icon icon-pigier-white"
          style={{ fill: "#ffffff" }}
        >
          <polygon
            className="cls-1"
            points="0 3.06 0 10.12 10.64 10.12 10.64 30.83 17.7 30.83 17.7 10.12 27.14 10.12 27.14 3.06 0 3.06"
          />
          <path
            className="cls-1"
            d="M74.78,3.06H61.44V30.83h7V10.12h6.29a6.74,6.74,0,0,1,6.74,6.74v14h7.06v-14a13.81,13.81,0,0,0-13.8-13.8"
          />
          <path
            className="cls-1"
            d="M139.7,3.06H126.36V30.83h7V10.12h6.29a6.74,6.74,0,0,1,6.74,6.74v14h7.05v-14A13.81,13.81,0,0,0,139.7,3.06"
          />
          <path
            className="cls-1"
            d="M50.48,23.77H44.2A6.75,6.75,0,0,1,37.45,17v-14H30.4V17a13.81,13.81,0,0,0,13.8,13.8H57.54V3.06H50.48Z"
          />
          <path
            className="cls-1"
            d="M112.58,14H106.8c-2.17,0-4.13.53-5,2.16l.13-.48c1-3.89,3.64-4.94,5.85-4.94h9.39c-.4,1.05-1.1,3.26-4.63,3.26m-2.69,5.88c-.62,2.42-1.94,4.17-4.2,4.17h-4c1.6,0,2.81-1.12,3.46-3.13l.86-2.77c.63-2.13,1.71-3.42,4.13-3.42h1.31ZM109.9,2C102.11,2,96,8.6,96.19,16.85a15.9,15.9,0,0,0,2,7.26A15.13,15.13,0,0,1,96.85,6.75,16.56,16.56,0,0,1,104,0,15.57,15.57,0,0,0,91.27,15.69c.25,9.14,7.23,16.54,16.07,16.54a16.19,16.19,0,0,0,16-16.44v-.1A13.87,13.87,0,0,0,109.9,2"
          />
        </svg>
      );
    } else if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "win"
    ) {
      return (
        <svg
          id="win"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 219.71 124.67"
          className="icon icon-pigier-white"
          style={{ fill: "#000" }}
        >
          <path
            className="cls-1"
            d="M65.26,108.43h5l-.36,1.31H66.37L66,111.12h3.12l-.36,1.29H65.65l-.38,1.42h3.61l-.36,1.32H63.45Zm3.32-2.23,1.23.55-1.55,1.15H67Z"
          />
          <path
            className="cls-1"
            d="M70.65,112.34a4.11,4.11,0,0,1,4.09-4,2.94,2.94,0,0,1,2.69,1.43l-1.22.86a1.84,1.84,0,0,0-1.65-.92,2.55,2.55,0,0,0-2.37,2.6,1.55,1.55,0,0,0,1.64,1.62,2.37,2.37,0,0,0,1.58-.66l1,1a3.59,3.59,0,0,1-2.55,1A2.9,2.9,0,0,1,70.65,112.34Z"
          />
          <path
            className="cls-1"
            d="M77.72,112.29a4,4,0,0,1,4-4,2.91,2.91,0,0,1,3.07,3,4,4,0,0,1-4,4A2.9,2.9,0,0,1,77.72,112.29Zm5.58-.91a1.59,1.59,0,0,0-1.71-1.7,2.49,2.49,0,0,0-2.33,2.51A1.58,1.58,0,0,0,81,113.9,2.49,2.49,0,0,0,83.3,111.38Z"
          />
          <path
            className="cls-1"
            d="M87.27,108.43h1.48l-1.44,5.37h3.35l-.36,1.35H85.47Z"
          />
          <path
            className="cls-1"
            d="M93.57,108.43h5l-.35,1.31H94.68l-.36,1.38h3.12l-.36,1.29H94l-.38,1.42h3.61l-.36,1.32H91.77Z"
          />
          <path
            className="cls-1"
            d="M103.41,108.43h2a3.55,3.55,0,0,1,2.63.86,2.64,2.64,0,0,1,.73,2,3.69,3.69,0,0,1-1.11,2.65,4.72,4.72,0,0,1-3.52,1.24h-2.49Zm.87,5.38a3.17,3.17,0,0,0,2.24-.81,2.36,2.36,0,0,0,.67-1.68,1.46,1.46,0,0,0-.39-1.07,2.1,2.1,0,0,0-1.55-.49h-.72l-1.09,4Z"
          />
          <path
            className="cls-1"
            d="M111.16,108.43h5l-.36,1.31h-3.55l-.36,1.38H115l-.36,1.29h-3.12l-.38,1.42h3.61l-.36,1.32h-5.07Z"
          />
          <path
            className="cls-1"
            d="M120.08,108.54h1.54l1,2.84,2.5-2.84h1.71l-1.8,6.72h-1.5l1.17-4.38L122,113.75h0l-1.07-2.84-1.17,4.35h-1.48Z"
          />
          <path
            className="cls-1"
            d="M130.93,108.5h1.42l1.07,6.76H131.9l-.21-1.5h-2.84l-1,1.5h-1.59Zm.59,4-.31-2.22-1.48,2.22Z"
          />
          <path
            className="cls-1"
            d="M136.34,108.54h1.36l2,4.28,1.15-4.28h1.46l-1.81,6.72h-1.25l-2-4.4-1.18,4.4h-1.46Z"
          />
          <path
            className="cls-1"
            d="M146.4,108.5h1.42l1.06,6.76h-1.51l-.21-1.5h-2.84l-1,1.5h-1.6Zm.58,4-.3-2.22-1.48,2.22Z"
          />
          <path
            className="cls-1"
            d="M150.09,112.46a4.13,4.13,0,0,1,4.19-4,3.29,3.29,0,0,1,2.75,1.16l-1.1,1a2.24,2.24,0,0,0-1.76-.78,2.6,2.6,0,0,0-2.55,2.63,1.57,1.57,0,0,0,1.72,1.61,2.9,2.9,0,0,0,1.2-.25l.32-1.1h-1.49l.34-1.28h2.92l-.95,3.35a4.71,4.71,0,0,1-2.44.64A2.91,2.91,0,0,1,150.09,112.46Z"
          />
          <path
            className="cls-1"
            d="M159.15,108.54h5l-.36,1.32h-3.55l-.36,1.37H163l-.36,1.3h-3.12l-.38,1.42h3.61l-.36,1.31h-5.07Z"
          />
          <path
            className="cls-1"
            d="M165.82,108.54h1.54l1,2.84,2.5-2.84h1.71l-1.8,6.72h-1.5l1.17-4.38-2.63,2.87h0l-1.07-2.84-1.17,4.35H164Z"
          />
          <path
            className="cls-1"
            d="M174.44,108.54h5l-.35,1.32h-3.55l-.37,1.37h3.12l-.35,1.3h-3.12l-.39,1.42h3.61l-.35,1.31h-5.07Z"
          />
          <path
            className="cls-1"
            d="M181.12,108.54h1.36l2,4.28,1.15-4.28h1.46l-1.81,6.72H184l-2-4.4-1.18,4.4h-1.46Z"
          />
          <path
            className="cls-1"
            d="M190,109.91H188l.37-1.37h5.56l-.36,1.37h-2.05L190,115.26h-1.47Z"
          />
          <path
            className="cls-1"
            d="M62.69,117.84h2a3.55,3.55,0,0,1,2.63.86,2.67,2.67,0,0,1,.72,2,3.68,3.68,0,0,1-1.1,2.65,4.8,4.8,0,0,1-3.52,1.24h-2.5Zm.86,5.38a3.2,3.2,0,0,0,2.25-.81,2.37,2.37,0,0,0,.67-1.68,1.46,1.46,0,0,0-.39-1.07,2.1,2.1,0,0,0-1.55-.49h-.72l-1.09,4Z"
          />
          <path
            className="cls-1"
            d="M69.29,122.4a3.9,3.9,0,0,1,.17-1.08l.93-3.48h1.47l-1,3.62a2.38,2.38,0,0,0-.11.73A1.05,1.05,0,0,0,72,123.3a1.52,1.52,0,0,0,1.1-.42,2.83,2.83,0,0,0,.65-1.25l1-3.79H76.2l-1.07,4a4.36,4.36,0,0,1-1,2,3.07,3.07,0,0,1-2.28.82C70.25,124.66,69.29,123.83,69.29,122.4Z"
          />
          <path
            className="cls-1"
            d="M79.21,123.41l1.11-.94a2.44,2.44,0,0,0,1.89.89c.59,0,1-.28,1-.7s-.24-.52-1.14-.89S80.44,121,80.44,120a2.4,2.4,0,0,1,2.67-2.22,3.26,3.26,0,0,1,2.51,1l-1,1A2.21,2.21,0,0,0,83,119c-.62,0-1,.34-1,.68s.27.51,1.18.88,1.62.84,1.62,1.82a2.4,2.4,0,0,1-2.67,2.23A3.5,3.5,0,0,1,79.21,123.41Z"
          />
          <path
            className="cls-1"
            d="M87.62,117.84h2.13a2.77,2.77,0,0,1,2.11.68,1.83,1.83,0,0,1,.52,1.38c0,1.67-1.43,2.62-3.26,2.62H87.84l-.55,2H85.82Zm1.57,3.39c1,0,1.65-.45,1.65-1.2a.75.75,0,0,0-.23-.56,1.2,1.2,0,0,0-.92-.3h-1l-.54,2.06Z"
          />
          <path
            className="cls-1"
            d="M93.15,121.7a4,4,0,0,1,4-4,2.91,2.91,0,0,1,3.07,3,4,4,0,0,1-4,4A2.9,2.9,0,0,1,93.15,121.7Zm5.58-.91a1.59,1.59,0,0,0-1.71-1.7,2.49,2.49,0,0,0-2.33,2.51,1.58,1.58,0,0,0,1.7,1.71A2.49,2.49,0,0,0,98.73,120.79Z"
          />
          <path
            className="cls-1"
            d="M102.7,117.84h2.45a2.86,2.86,0,0,1,2.13.67,1.86,1.86,0,0,1,.52,1.35,2.42,2.42,0,0,1-2.17,2.4l1.14,2.3h-1.68l-1-2.15H103l-.57,2.15H100.9Zm1.92,3.26c.92,0,1.63-.37,1.63-1.11a.68.68,0,0,0-.21-.54,1.38,1.38,0,0,0-1-.28h-1.23l-.52,1.93Z"
          />
          <path
            className="cls-1"
            d="M111,119.2h-2l.37-1.36h5.56l-.36,1.36h-2.05l-1.44,5.36h-1.47Z"
          />
          <path
            className="cls-1"
            d="M44.35,124.65H25.82a1.76,1.76,0,0,1-1.72-2.46l28-92.91a3.58,3.58,0,0,1,3.19-2.45H73.84a1.76,1.76,0,0,1,1.72,2.45l-28,92.91A3.56,3.56,0,0,1,44.35,124.65Z"
          />
          <path
            className="cls-1"
            d="M90.31,101.48H71.77A1.76,1.76,0,0,1,70.06,99L99.34,3.27A3.57,3.57,0,0,1,102.53.82h18.53a1.77,1.77,0,0,1,1.72,2.45L93.5,99A3.59,3.59,0,0,1,90.31,101.48Z"
          />
          <path
            className="cls-1"
            d="M20.36,26.81H1.83A1.76,1.76,0,0,0,.11,29.27l22,92.92a3.56,3.56,0,0,0,3.19,2.46H43.83a1.77,1.77,0,0,0,1.72-2.46l-22-92.92A3.59,3.59,0,0,0,20.36,26.81Z"
          />
          <path
            className="cls-1"
            d="M73.77,26.83H55.24a1.76,1.76,0,0,0-1.72,2.45L68.69,99a3.57,3.57,0,0,0,3.19,2.46H90.41A1.76,1.76,0,0,0,92.13,99L77,29.28A3.58,3.58,0,0,0,73.77,26.83Z"
          />
          <path
            className="cls-1"
            d="M121.72,101.48H103.18A1.77,1.77,0,0,1,101.46,99l21.25-69.74a3.58,3.58,0,0,1,3.19-2.45h18.54a1.76,1.76,0,0,1,1.71,2.45L124.9,99A3.56,3.56,0,0,1,121.72,101.48Z"
          />
          <path
            className="cls-1"
            d="M153,101.48H134.5A1.76,1.76,0,0,1,132.78,99L154,29.28a3.55,3.55,0,0,1,3.19-2.45h18.53a1.76,1.76,0,0,1,1.72,2.45L156.22,99A3.57,3.57,0,0,1,153,101.48Z"
          />
          <path
            className="cls-1"
            d="M195.16,101.48H176.63A1.76,1.76,0,0,1,174.91,99l21.25-69.74a3.56,3.56,0,0,1,3.19-2.45h18.53a1.76,1.76,0,0,1,1.72,2.45L198.35,99A3.57,3.57,0,0,1,195.16,101.48Z"
          />
          <path
            className="cls-1"
            d="M176.6,26.83H158.06a1.76,1.76,0,0,0-1.72,2.45L171.52,99a3.56,3.56,0,0,0,3.18,2.46h18.54A1.77,1.77,0,0,0,195,99L179.78,29.28A3.55,3.55,0,0,0,176.6,26.83Z"
          />
          <circle className="cls-1" cx="139.97" cy="11.23" r="11.23" />
          <path
            className="cls-1"
            d="M188.5,124.56H118a1.5,1.5,0,0,1-1.46-1.84l.54-2.37a1.5,1.5,0,0,1,1.46-1.16H189a1.51,1.51,0,0,1,1.47,1.84l-.55,2.36A1.5,1.5,0,0,1,188.5,124.56Z"
          />
        </svg>
      );
    } if (
      this.props.marque != null &&
      this.props.marque.logo != null &&
      this.props.marque.logo === "studio-m"
    ) {
      return (
        <img className="logo" src={logo_studio_m} alt="Logo Studio M"/>
      );
    }
    else {
      return (
        <svg
          id="eduservices"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 60 50"
          className="icon icon-pigier-white"
          style={{ width: "4rem", fill: "#ffffff" }}
        >
          <path d="M32.83,40.5c6-6.53,19.64-9,19.64-9h-.08V19.82L32.84,27.53,13.21,19.79V31.5c8.63,0,19.62,9,19.62,9" />
          <polygon points="47.4 20.24 27.52 12.73 32.76 10.71 52.64 18.23 65.68 12.95 32.84 0 0 12.95 32.84 25.91 47.4 20.24" />
        </svg>
      );
    }
  }
}

export default Logo;

/*


*/
